import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  "en": {
    "translation": {
      "Dashboard": "Dashboard",
      "Prevent TB - Tajikistan": "Prevent TB Tajikistan",
      "home": "Home",
      "Line List": "Line List",
      "Alerts": "Alerts",
      "Smart Setup": "Smart Setup",
      "Users": "Users",
      "Index Upload": "Index Upload",
      "QR Code": "QR Code",
      "QR Code Generation": "QR Code Generation",
      "Logout": "Logout",
      "Reset ": "Reset ",
      "Index registered": "Index Registered",
      "Key population Registered": "Key Population Registered",
      "Contact registered": "Contact Registered",
      "Contact screened": "Contact Screened",
      "Referred to Investigation - TB": "Referred To Investigation - TB",
      "Referred to Investigation - LTBI": "Referred To Investigation - LTBI",
      "TB Negative": "TB Negative",
      "TB Postive": "TB Postive",
      "LTBI Negative": "LTBI Negative",
      "LTBI Positive": "LTBI Positive",
      "Total registered - Index and Contact": "Total Registered - Index And Contact",
      "TB and LTBI cases": "TB And LTBI Cases",
      "TB testing - Positive": "TB Testing - Positive",
      "LTBI testing - Positive": "LTBI Testing - Positive",
      "Gender": "Gender",
      "Reset Map": "Reset Map",
      "Gender (male)": "Gender (Male)",
      "Gender (female)": "Gender (Female)",
      "Gender (TG)": "Gender (TG)",
      "Hotspot Details": "Hotspot Details",
      "Select Filter": "Select Filter",
      "Organisation Units": "Organisation Units",
      "Tajikistan": "Tajikistan",
      "Period": "Period",
      "Period Type": "Period Type",
      "Yearly": "Yearly",
      "Apply": "Apply",
      "Powered By": "Powered By",
      "null": null,
      "All": "All",
      "Index": "Index",
      "Contact": "Contact",
      "Key Population": "Key Population",
      "Search": "Search",
      "Cases": "Cases",
      "Page": "Page",
      "Go to page": "Go To The Page",
      "Show": "Show",
      "Export Data": "Export Data",
      "UIC": "UIC",
      " Name": "Name",
      "Name": "Name",
      "District": "District",
      "Mobile Number": "Mobile Number",
      "Age (in years)": "Age (in years)",
      "Observation Type": "Observation Type",
      "Presently on anti-TB medication?": "Presently on anti-TB medication?",
      "ALERTS": "ALERTS",
      "Threshold Value": "Threshold Value",
      "Days": "Days",
      "No Data": "No Data",
      "Enter Number of QR Codes to be Generated": "Enter Number of QR Codes to be Generated",
      "Generate": "Generate",
      "Upload": "Upload",
      "Total Registered - Index And Contact": "Total Registered - Index And Contact",
      "Leaflet": "Leaflet",
      "N/A": "N/A",
      "of": "Of",
      "Registered By": "Registered By",
      "Select Role": "Select Role",
      "Select User": "Select User",
      "Select Organisation Unit": "Select Organisation Unit",
      "Select Municipality": "Select Region",
      "Select CHC": "Select District",
      "Select Block": "Select Facility",
      "Enter Number of QR Codes to be Generated": "Enter Number of QR Codes to be Generated",
      "Generate QR Code": "Generate QR Code",
      "Age": "AGE",
      "Are you sure you want to logout?": "Are you sure you want to logout?",
      "& Above": "& Above",
      "Yes": "Yes",
      "No": "No",
      "Date Range": "Date range",
      "Monthly": "Monthly",
      "Quarterly": "Quarterly",
      "Yearly": "Yearly",
      "No Alerts": "No Alerts",
      "records": "records",
      "Details": "Details",
      "Treatment Initiation": "Treatment Initiation",
      "Select": "Select",
      "All Rights Reserved" : "All Rights Reserved",
      "Quarter 1(Jan-Mar)" : "Quarter 1(Jan-Mar)",
      "Quarter 2(Apr-Jun)" : "Quarter 2(Apr-Jun)",
      "Quarter 3(Jul-Sep)" : "Quarter 3(Jul-Sep)",
      "Quarter 4(Oct-Dec)" : "Quarter 4(Oct-Dec)",
      // ORG LABELS..........................................................................................................................
      "РРП": "РРП",
      "Сугд": "Сугд",
      "Хатлон": "Хатлон",
      "GBAO": "GBAO",
      "Dushanbe": "Dushanbe",
      "Rudaki": "Rudaki",
      "Vahdat": "Vahdat",
      "Varzob": "Varzob",
      "Hisor": "Hisor",
      "Lahsh": "Lahsh",
      "Nurobod": "Nurobod",
      "Rasht": "Rasht",
      "Rogun": "Rogun",
      "Sangvor": "Sangvor",
      "Tojikobod": "Tojikobod",
      "Tursunzoda": "Tursunzoda",
      "Fayzobod": "Fayzobod",
      "Shahrinav": "Shahrinav",
      "Khujand": "Khujand",
      "Guliston": "Guliston",
      "Istiqlol": "Istiqlol",
      "Buston": "Buston",
      "Ayni": "Ayni",
      "Asht": "Asht",
      "B.Gafurov": "B.Gafurov",
      "Devashtich": "Devashtich",
      "Kuhistoni Mastchoh": "Kuhistoni Mastchoh",
      "J.Rasulov": "J.Rasulov",
      "Zafarobod": "Zafarobod",
      "Istaravshan": "Istaravshan",
      "Isfara": "Isfara",
      "Konibodom": "Konibodom",
      "Mastchoh": "Mastchoh",
      "Panjakent": "Panjakent",
      "Spitamen": "Spitamen",
      "Shahriston": "Shahriston",
      "Bokhtar": "Bokhtar",
      "Kulob": "Kulob",
      "Levakant": "Levakant",
      "A.Jomi": "A.Jomi",
      "Baljuvon": "Baljuvon",
      "Kushoniyon": "Kushoniyon",
      "Vahsh": "Vahsh",
      "Vose": "Vose",
      "Dangara": "Dangara",
      "J.Balkhi": "J.Balkhi",
      "Dusti": "Dusti",
      "Qubodiyon": "Qubodiyon",
      "Jayhun": "Jayhun",
      "Hamadoni": "Hamadoni",
      "Muminobod": "Muminobod",
      "N.Hisrav": "N.Hisrav",
      "Norak": "Norak",
      "Panj": "Panj",
      "Temurmalik": "Temurmalik",
      "Farhor": "Farhor",
      "Hovaling": "Hovaling",
      "Huroson": "Huroson",
      "Shahritus": "Shahritus",
      "Sh.Shohin": "Sh.Shohin",
      "Yovon": "Yovon",
      "Khorug": "Khorug",
      "Vanj": "Vanj",
      "Darvoz": "Darvoz",
      "Ishkoshim": "Ishkoshim",
      "Murgob": "Murgob",
      "Roshqala": "Roshqala",
      "Rushon": "Rushon",
      "Shugnon": "Shugnon",
      "PHC №2": "PHC №2",
      "PHC №3": "PHC №3",
      "PHC №4": "PHC №4",
      "PHC №5": "PHC №5",
      "PHC №6": "PHC №6",
      "PHC №7": "PHC №7",
      "PHC №8": "PHC №8",
      "PHC №9": "PHC №9",
      "PHC №10": "PHC №10",
      "PHC №11": "PHC №11",
      "PHC №12": "PHC №12",
      "PHC №1": "PHC №1",
      "PHC №14": "PHC №14",
      "PHC №15": "PHC №15",
      "Zaynabobod": "Zaynabobod",
      "Russia": "Russia",
      "Rohati": "Rohati",
      "Qiblai": "Qiblai",
      "Guliston ": "Guliston ",
      "Sultonobod": "Sultonobod",
      "Somoniyon": "Somoniyon",
      "Esanboy": "Esanboy",
      "Chorgulteppa": "Chorgulteppa",
      "Lohur": "Lohur",
      "Ishkobod": "Ishkobod",
      "Chimteppa": "Chimteppa",
      "Sarikishti": "Sarikishti",
      "Navobod": "Navobod",
      "Chorteppa": "Chorteppa",
      "Choryakkaron": "Choryakkaron",
      "DOTS 2": "DOTS 2",
      "DOTS 3": "DOTS 3",
      "RHC Romit": "RHC Romit",
      "Yavroz": "Yavroz",
      "Hushon": "Hushon",
      "Sayod": "Sayod",
      "Vistan": "Vistan",
      "Tvishi poyon": "Tvishi poyon",
      "Sorvo": "Sorvo",
      "Loshharf": "Loshharf",
      "Varva": "Varva",
      "Yafrak": "Yafrak",
      "RHC Tangay": "RHC Tangay",
      "RHC Lichak": "RHC Lichak",
      "Shorazm": "Shorazm",
      "Chuyangaron": "Chuyangaron",
      "Hordara": "Hordara",
      "RHC Amonshayhi": "RHC Amonshayhi",
      "Shahdrez": "Shahdrez",
      "RHC Chorbog": "RHC Chorbog",
      "Yums ": "Yums ",
      "RHC Bakaron": "RHC Bakaron",
      "Shabgardi": "Shabgardi",
      "RHC Simiganj": "RHC Simiganj",
      "RHC Firishti": "RHC Firishti",
      "Arbobi": "Arbobi",
      "Panjikon": "Panjikon",
      "Odily": "Odily",
      "Sarchinor": "Sarchinor",
      "RHC navruz": "RHC navruz",
      "RHC Kipchok": "RHC Kipchok",
      "Nozirobod": "Nozirobod",
      "RHC Hojikatagan": "RHC Hojikatagan",
      "Guliston ": "Guliston ",
      "Zafarobod": "Zafarobod",
      "Machiton": "Machiton",
      "Gulbog": "Gulbog",
      "RHC Kamongaron": "RHC Kamongaron",
      "RHC Bahor": "RHC Bahor",
      "Pistamazor": "Pistamazor",
      "RHC Guliston": "RHC Guliston",
      "Dahana": "Dahana",
      "Hirgatarosh": "Hirgatarosh",
      "Dehqonobod": "Dehqonobod",
      "RHC Tilloi safed": "RHC Tilloi safed",
      "Jarteppa": "Jarteppa",
      "Kuhdoman": "Kuhdoman",
      "RHC Buston": "RHC Buston",
      "Kishovarz": "Kishovarz",
      "Hakikat": "Hakikat",
      "Jangalobod": "Jangalobod",
      "Adolat": "Adolat",
      "RHC Mehrbahsh": "RHC Mehrbahsh",
      "Abdurasuli": "Abdurasuli",
      "Madaniyat-1": "Madaniyat-1",
      "Navbahor": "Navbahor",
      "Istiqloliyat": "Istiqloliyat",
      "Surhchashma": "Surhchashma",
      "Madaniyat-2": "Madaniyat-2",
      "RHC Ganjbor": "RHC Ganjbor",
      "Sitorai surh": "Sitorai surh",
      "Charboshi": "Charboshi",
      "RHC Dusti": "RHC Dusti",
      "Muminobod": "Muminobod",
      "RHC Qarsang": "RHC Qarsang",
      "Buzbit": "Buzbit",
      "RHC Navobod": "RHC Navobod",
      "Mehnatobod": "Mehnatobod",
      "RHC Boston": "RHC Boston",
      "Arbobdara": "Arbobdara",
      "Naydara": "Naydara",
      "Sangpar": "Sangpar",
      "Sugdiyon": "Sugdiyon",
      "Gurghurda": "Gurghurda",
      "Holmurodi": "Holmurodi",
      "RHC Bahoriston": "RHC Bahoriston",
      "Zardolu": "Zardolu",
      "Qalai mali": "Qalai mali",
      "Yalanchinor": "Yalanchinor",
      "Chepisoleh": "Chepisoleh",
      "Gulakandoz": "Gulakandoz",
      "Galchari": "Galchari",
      "Geshi": "Geshi",
      "RHC B.Burunov": "RHC B.Burunov",
      "Fayzbahsh": "Fayzbahsh",
      "Mehrobod": "Mehrobod",
      "RHC Girdob": "RHC Girdob",
      "Chirtak": "Chirtak",
      "RHC Shifo": "RHC Shifo",
      "Javonon": "Javonon",
      "Shirinchashma": "Shirinchashma",
      "Zarteppa": "Zarteppa",
      "RHC Solehon": "RHC Solehon",
      "Sarchashma": "Sarchashma",
      "Zulfi": "Zulfi",
      "Sufiyon": "Sufiyon",
      "RHC Gulrez": "RHC Gulrez",
      "Andigon": "Andigon",
      "Ganjina": "Ganjina",
      "RHC Chillamazor": "RHC Chillamazor",
      "Sharifobod": "Sharifobod",
      "Zargar": "Zargar",
      "Mehrgon": "Mehrgon",
      "RHC Kofarnihon": "RHC Kofarnihon",
      "Chinor": "Chinor",
      "Dashtibedi kalon": "Dashtibedi kalon",
      "Dashtibedi hurd": "Dashtibedi hurd",
      "Elovar": "Elovar",
      "Obidara": "Obidara",
      "Chaman": "Chaman",
      "Bahoriston": "Bahoriston",
      "Hisor TB Center": "Hisor TB Center",
      "Almosi": "Almosi",
      "Bobosurhon": "Bobosurhon",
      "Vatan": "Vatan",
      "Guli surh": "Guli surh",
      "Gulhani": "Gulhani",
      "Gayratobod": "Gayratobod",
      "Guriyot": "Guriyot",
      "Dehqonobod": "Dehqonobod",
      "Durbat": "Durbat",
      "Duchinora": "Duchinora",
      "Iskich": "Iskich",
      "Kavshduzon": "Kavshduzon",
      "Dahbed": "Dahbed",
      "Mehrobod": "Mehrobod",
      "Niyogon": "Niyogon",
      "Mehrgon": "Mehrgon",
      "Lolagi": "Lolagi",
      "Morteppa": "Morteppa",
      "Navobod": "Navobod",
      "Nilu": "Nilu",
      "Nochi-bolo": "Nochi-bolo",
      "Oybosh": "Oybosh",
      "Sumbula": "Sumbula",
      "Sangchashma": "Sangchashma",
      "Tuda": "Tuda",
      "Uzbekiston": "Uzbekiston",
      "Hayotinav": "Hayotinav",
      "Honakoi Kuhi": "Honakoi Kuhi",
      "Hiloli Ahmar": "Hiloli Ahmar",
      "Hisor": "Hisor",
      "Sugdiyon": "Sugdiyon",
      "Javoni": "Javoni",
      "Halkarud": "Halkarud",
      "Sharora": "Sharora",
      "Nurafshon": "Nurafshon",
      "Tursunzoda TB Center": "Tursunzoda TB Center",
      "Durbent": "Durbent",
      "Dusti": "Dusti",
      "Kommunizm": "Kommunizm",
      "Quzi-bacha": "Quzi-bacha",
      "Leninizm": "Leninizm",
      "Moskva": "Moskva",
      "Pahtashirkat": "Pahtashirkat",
      "Pahtakor": "Pahtakor",
      "Pravda": "Pravda",
      "Sarkor": "Sarkor",
      "Toychi": "Toychi",
      "Husnobod": "Husnobod",
      "Chkalov": "Chkalov",
      "Pahtaobod": "Pahtaobod",
      "Yangiturmush": "Yangiturmush",
      "Efiranos": "Efiranos",
      "Devak": "Devak",
      "Beshteppa": "Beshteppa",
      "Chinor": "Chinor",
      "Qaratog": "Qaratog",
      "Qizil-nishon": "Qizil-nishon",
      "Kalinin": "Kalinin",
      "Frunze": "Frunze",
      "Oqtosh": "Oqtosh",
      "Batosh": "Batosh",
      "Guliston ": "Guliston ",
      "Oqtelpak": "Oqtelpak",
      "Istiqlol": "Istiqlol",
      "Shahrinav TB Center": "Shahrinav TB Center",
      "Navobod": "Navobod",
      "Qadi juybor": "Qadi juybor",
      "Shurob": "Shurob",
      "Istiqlol": "Istiqlol",
      "Pahtakor": "Pahtakor",
      "Bahoriston": "Bahoriston",
      "Chust": "Chust",
      "Uzun": "Uzun",
      "Dehobod": "Dehobod",
      "Eloki": "Eloki",
      "Sangala": "Sangala",
      "Tojikistan": "Tojikistan",
      "Bogiston": "Bogiston",
      "Dolon": "Dolon",
      "Ajam": "Ajam",
      "Akram Hasan": "Akram Hasan",
      "Muloshodi": "Muloshodi",
      "M.Tursunzoda": "M.Tursunzoda",
      "Khujand TB Center": "Khujand TB Center",
      "CHC №1 Khujand": "CHC №1 Khujand",
      "CHC №2 Khujand": "CHC №2 Khujand",
      "CHC №3 Khujand": "CHC №3 Khujand",
      "CHC №4 Khujand": "CHC №4 Khujand",
      "CHC №5 Khujand": "CHC №5 Khujand",
      "Guliston TB Center": "Guliston TB Center",
      "CHC Qayroqum": "CHC Qayroqum",
      "Adrasmon": "Adrasmon",
      "Zarnisor": "Zarnisor",
      "Konsoy": "Konsoy",
      "Sirdaryo": "Sirdaryo",
      "Choruqdarron": "Choruqdarron",
      "Navgarzan": "Navgarzan",
      "Istiqlol TB Center": "Istiqlol TB Center",
      "CHC Istiqlol": "CHC Istiqlol",
      "Buston TB Center": "Buston TB Center",
      "CHC Buston": "CHC Buston",
      "Ayni TB Center": "Ayni TB Center",
      "District HC Ayni": "District HC Ayni",
      "Aslonobod": "Aslonobod",
      "Veshab": "Veshab",
      "Veshkand": "Veshkand",
      "Darg": "Darg",
      "Dardar": "Dardar",
      "Kum": "Kum",
      "Zerabod": "Zerabod",
      "Zoosun": "Zoosun",
      "Madm": "Madm",
      "Pohut": "Pohut",
      "Rarz": "Rarz",
      "Revad": "Revad",
      "Urmetan": "Urmetan",
      "Shavadki bolo": "Shavadki bolo",
      "Shamtuch": "Shamtuch",
      "District HC №1 Zarafshon": "District HC №1 Zarafshon",
      "Tagi Chinor": "Tagi Chinor",
      "Gaberut": "Gaberut",
      "Mahshevad": "Mahshevad",
      "Dijik": "Dijik",
      "Asht TB Center": "Asht TB Center",
      "District HC Shaydon": "District HC Shaydon",
      "Bobokir": "Bobokir",
      "Makarenko": "Makarenko",
      "Dusti": "Dusti",
      "Asht": "Asht",
      "Oriyon": "Oriyon",
      "Qamishqurgan": "Qamishqurgan",
      "Djigda": "Djigda",
      "Iftihor": "Iftihor",
      "Marhamat": "Marhamat",
      "Appon": "Appon",
      "Oshoba": "Oshoba",
      "Sudja": "Sudja",
      "Saro": "Saro",
      "Bobodarhon": "Bobodarhon",
      "Pushta": "Pushta",
      "Pongoz": "Pongoz",
      "Punuk": "Punuk",
      "Gulshan": "Gulshan",
      "B.Gafurov TB Center": "B.Gafurov TB Center",
      "District HC B.Gafurov": "District HC B.Gafurov",
      "Qistakoz": "Qistakoz",
      "Histavers": "Histavers",
      "Zarzamin": "Zarzamin",
      "Tojikistan": "Tojikistan",
      "A.Sattorov": "A.Sattorov",
      "Kintirik": "Kintirik",
      "Yava": "Yava",
      "Toshloq": "Toshloq",
      "Sirdaryo": "Sirdaryo",
      "H.Usmon": "H.Usmon",
      "Odil": "Odil",
      "Undji": "Undji",
      "Dashtak": "Dashtak",
      "Isfisor": "Isfisor",
      "Hodjent": "Hodjent",
      "Dashti Amin": "Dashti Amin",
      "Ismoil": "Ismoil",
      "Baht": "Baht",
      "Qizil Yulduz": "Qizil Yulduz",
      "Ovuchi kalacha": "Ovuchi kalacha",
      "Kulangir": "Kulangir",
      "Utkansoy": "Utkansoy",
      "Oktepa": "Oktepa",
      "Gaziyan": "Gaziyan",
      "Chorsu": "Chorsu",
      "Kotma": "Kotma",
      "Vodnik": "Vodnik",
      "Bogparvar": "Bogparvar",
      "Devashtich TB Center": "Devashtich TB Center",
      "District HC Devashtich": "District HC Devashtich",
      "District HC №1 Kalininobod": "District HC №1 Kalininobod",
      "Lolazor": "Lolazor",
      "Hushtoiri Muhlon": "Hushtoiri Muhlon",
      "Zarnisor": "Zarnisor",
      "Muchun": "Muchun",
      "Nurobod": "Nurobod",
      "Istiqlol": "Istiqlol",
      "hazorchashma": "hazorchashma",
      "Surhob": "Surhob",
      "Basmanda": "Basmanda",
      "Ovchi": "Ovchi",
      "Dahkat": "Dahkat",
      "Hishekat": "Hishekat",
      "Rosrovut": "Rosrovut",
      "Metk": "Metk",
      "Dalyani Bolo": "Dalyani Bolo",
      "Dalyani poyon": "Dalyani poyon",
      "Kuhistoni Mastchoh TB Center": "Kuhistoni Mastchoh TB Center",
      "District HC Kuhistoni Mastchoh": "District HC Kuhistoni Mastchoh",
      "Madrushkat": "Madrushkat",
      "Pastigav": "Pastigav",
      "Revomutk": "Revomutk",
      "Rog": "Rog",
      "Esiz": "Esiz",
      "Regional TB Center Dehmoy": "Regional TB Center Dehmoy",
      "District HC J.Rasulov": "District HC J.Rasulov",
      "4-um Mahlla": "4-um Mahlla",
      "Guliston": "Guliston",
      "Yangiqishloq": "Yangiqishloq",
      "Yangiobod": "Yangiobod",
      "Qurgoncha": "Qurgoncha",
      "Gulhona": "Gulhona",
      "Gulyakindoz": "Gulyakindoz",
      "Dehmoy": "Dehmoy",
      "Zarafshon": "Zarafshon",
      "Parij Kommuna": "Parij Kommuna",
      "Tojikobod": "Tojikobod",
      "Uzbekqishloq": "Uzbekqishloq",
      "Yangiqadam": "Yangiqadam",
      "Zafarobod TB Center": "Zafarobod TB Center",
      "CHC Zafarobod": "CHC Zafarobod",
      "Baht": "Baht",
      "Guliston": "Guliston",
      "Hayoti Nav": "Hayoti Nav",
      "Hamid Aliyev": "Hamid Aliyev",
      "Login": "Login",
      "Mehnatobod": "Mehnatobod",
      "Jomi": "Jomi",
      "Zarafshon (Komsomol)": "Zarafshon (Komsomol)",
      "Istaravshan TB Center": "Istaravshan TB Center",
      "HC №1": "HC №1",
      "HC №2": "HC №2",
      "Bobotago": "Bobotago",
      "Bogkalon": "Bogkalon",
      "Varsi": "Varsi",
      "Vogat": "Vogat",
      "Qalai baland": "Qalai baland",
      "Qalachai kalon": "Qalachai kalon",
      "Kurushkada": "Kurushkada",
      "lakat": "lakat",
      "Mahallai Yasi": "Mahallai Yasi",
      "Nijoni": "Nijoni",
      "Nofaroj": "Nofaroj",
      "Obodi": "Obodi",
      "Rugund": "Rugund",
      "Orif": "Orif",
      "Toshbek": "Toshbek",
      "Chavkandak": "Chavkandak",
      "Chorqurgon": "Chorqurgon",
      "Chorbosh": "Chorbosh",
      "Yakkabosh": "Yakkabosh",
      "Isfara TB Center": "Isfara TB Center",
      "CHC Isfara": "CHC Isfara",
      "Navgilem": "Navgilem",
      "Oftobru": "Oftobru",
      "Kulkent": "Kulkent",
      "Chilgizi": "Chilgizi",
      "Lakkon": "Lakkon",
      "Neftobod": "Neftobod",
      "Zarkuh": "Zarkuh",
      "Nurafshon": "Nurafshon",
      "Matpari": "Matpari",
      "Chorqishloq": "Chorqishloq",
      "Surh": "Surh",
      "Chorkuh": "Chorkuh",
      "Voruh": "Voruh",
      "Honaobod": "Honaobod",
      "Saridasht": "Saridasht",
      "Tidon": "Tidon",
      "Shurob": "Shurob",
      "Hojai Alo": "Hojai Alo",
      "Konibodom TB Center": "Konibodom TB Center",
      "CHC Konibodom": "CHC Konibodom",
      "Niyozbek": "Niyozbek",
      "Mahram": "Mahram",
      "Hamroboev": "Hamroboev",
      "Hamirjuy": "Hamirjuy",
      "Ortiqov": "Ortiqov",
      "Dilovaron (Shaitkaroyan)": "Dilovaron (Shaitkaroyan)",
      "Shurqurgon": "Shurqurgon",
      "Zarbed": "Zarbed",
      "Kuruk": "Kuruk",
      "Puloton": "Puloton",
      "Ravot": "Ravot",
      "Patar": "Patar",
      "Galaba": "Galaba",
      "Dusti (Assor)": "Dusti (Assor)",
      "Jahonzeb (Qaraqchiqum)": "Jahonzeb (Qaraqchiqum)",
      "Lohuti": "Lohuti",
      "Mastchoh TB Center": "Mastchoh TB Center",
      "District HC Mastchoh": "District HC Mastchoh",
      "J.Mastchoh": "J.Mastchoh",
      "Azizobod (M.Komsomoli)": "Azizobod (M.Komsomoli)",
      "J.Obburdon ": "J.Obburdon ",
      "Fayz Sulton": "Fayz Sulton",
      "J.Paldorak ": "J.Paldorak ",
      "J.Avzikent (Navbahor)": "J.Avzikent (Navbahor)",
      "J.Kuruksoy Obshoron": "J.Kuruksoy Obshoron",
      "Panjakent TB Center": "Panjakent TB Center",
      "CHC Panjakent": "CHC Panjakent",
      "Hurmi": "Hurmi",
      "Ozodagon": "Ozodagon",
      "Shingak": "Shingak",
      "Voru": "Voru",
      "Ruknobod": "Ruknobod",
      "Porven": "Porven",
      "Maykatta": "Maykatta",
      "Amondara": "Amondara",
      "Ravot": "Ravot",
      "Navruzteppa": "Navruzteppa",
      "Shurcha": "Shurcha",
      "Sangi kabud": "Sangi kabud",
      "Farob": "Farob",
      "Sarazm": "Sarazm",
      "CHC Sarazm": "CHC Sarazm",
      "Shurnova": "Shurnova",
      "Childara": "Childara",
      "Chimqala": "Chimqala",
      "Mazor": "Mazor",
      "Gusar": "Gusar",
      "Navobod": "Navobod",
      "Dashto Qozi": "Dashto Qozi",
      "Mindona": "Mindona",
      "Yori": "Yori",
      "Kuloli": "Kuloli",
      "Artuch": "Artuch",
      "Panjrud": "Panjrud",
      "Negnot": "Negnot",
      "Margedar": "Margedar",
      "Dasht": "Dasht",
      "Qumsoy": "Qumsoy",
      "Suchina": "Suchina",
      "Filmandar": "Filmandar",
      "Kosatarosh": "Kosatarosh",
      "Sogdiana": "Sogdiana",
      "Chorbog": "Chorbog",
      "Mogiyon": "Mogiyon",
      "Sor": "Sor",
      "Gezan": "Gezan",
      "Shing": "Shing",
      "Toshmunor": "Toshmunor",
      "Spitamen TB Center": "Spitamen TB Center",
      "District HC №1 Spitamen": "District HC №1 Spitamen",
      "District HC №2 Spitamen": "District HC №2 Spitamen",
      "hurramzamin": "hurramzamin",
      "Oktepa": "Oktepa",
      "Havatag": "Havatag",
      "Yangtobod": "Yangtobod",
      "Qushtegirmon": "Qushtegirmon",
      "Saidkurgon": "Saidkurgon",
      "Togoyak": "Togoyak",
      "Langar": "Langar",
      "Shahriston TB Center": "Shahriston TB Center",
      "District HC Shahriston": "District HC Shahriston",
      "Obodi": "Obodi",
      "Sebzor": "Sebzor",
      "Bokhtar TB Center": "Bokhtar TB Center",
      "CHC Bokhtar": "CHC Bokhtar",
      "Child HC Bokhtar": "Child HC Bokhtar",
      "Sarchashma (Nihi)": "Sarchashma (Nihi)",
      "Gayrat": "Gayrat",
      "Hayoti Nav": "Hayoti Nav",
      "Zarbdor": "Zarbdor",
      "Kulob TB Center": "Kulob TB Center",
      "Regional HC Kulob": "Regional HC Kulob",
      "District HC Kulob": "District HC Kulob",
      "Honobod": "Honobod",
      "Dahana": "Dahana",
      "Saryozii bolo": "Saryozii bolo",
      "Ziraki": "Ziraki",
      "Aftobluk": "Aftobluk",
      "Hakimobod": "Hakimobod",
      "Lagmon": "Lagmon",
      "Chorbog": "Chorbog",
      "Khatlon": "Khatlon",
      "Panjosiyob": "Panjosiyob",
      "CHC №1 Kulyab": "CHC №1 Kulyab",
      "CHC №2 Kulyab": "CHC №2 Kulyab",
      "Child HC Kulyab": "Child HC Kulyab",
      "Levakant Tb Center": "Levakant Tb Center",
      "CHC Sarband": "CHC Sarband",
      "Bohturobod": "Bohturobod",
      "Guliston": "Guliston",
      "Okgaza №1": "Okgaza №1",
      "Kuli Sufiyon": "Kuli Sufiyon",
      "A.Jomi TB Center": "A.Jomi TB Center",
      "District HC A.Jomi": "District HC A.Jomi",
      "Bahor": "Bahor",
      "Dusti (Yakkatut)": "Dusti (Yakkatut)",
      "Tojikiston": "Tojikiston",
      "Lenin (Qadridin Giyosov)": "Lenin (Qadridin Giyosov)",
      "Kalenin (Gulobod)": "Kalenin (Gulobod)",
      "Galaba": "Galaba",
      "Mehnat": "Mehnat",
      "Baljuvon TB Center": "Baljuvon TB Center",
      "District HC Baljuvon": "District HC Baljuvon",
      "RHC Oqbuloq": "RHC Oqbuloq",
      "RHC Sari hosor (Shahidon)": "RHC Sari hosor (Shahidon)",
      "Hoirob": "Hoirob",
      "Sari mazor": "Sari mazor",
      "Chorbog": "Chorbog",
      "Sulmolidasht": "Sulmolidasht",
      "Navbahor (Satalmush)": "Navbahor (Satalmush)",
      "Zarnisor (Dektur)": "Zarnisor (Dektur)",
      "Dashti Maydon": "Dashti Maydon",
      "Guldara": "Guldara",
      "Shingidara": "Shingidara",
      "Kushoniyon TB Center": "Kushoniyon TB Center",
      "District HCC Kushoniyon": "District HCC Kushoniyon",
      "Voroshilov": "Voroshilov",
      "Zargar": "Zargar",
      "Komsomol": "Komsomol",
      "Pahtakor": "Pahtakor",
      "F.Saidov 3": "F.Saidov 3",
      "1-department": "1-department",
      "4-department": "4-department",
      "Navobod": "Navobod",
      "Urtabuz": "Urtabuz",
      "Sarvati Istiqlol": "Sarvati Istiqlol",
      "Lenin": "Lenin",
      "Sverdlov": "Sverdlov",
      "Navkor": "Navkor",
      "Marksizm": "Marksizm",
      "Chorsu": "Chorsu",
      "Istiqlol": "Istiqlol",
      "S. Ayni": "S. Ayni",
      "Navbahor": "Navbahor",
      "Buston-Qal'a": "Buston-Qal'a",
      "SMP-540": "SMP-540",
      "Sabzavot": "Sabzavot",
      "Rohi Lenin": "Rohi Lenin",
      "Mehnatobod": "Mehnatobod",
      "Vakhsh TB Center": "Vakhsh TB Center",
      "District HCC Вахш": "District HCC Вахш",
      "Rudaki": "Rudaki",
      "Kirov 1": "Kirov 1",
      "S. Turdiyev": "S. Turdiyev",
      "Kulob": "Kulob",
      "Aynidin Kurbonov": "Aynidin Kurbonov",
      "Uzbekiston (Peshqadam)": "Uzbekiston (Peshqadam)",
      "Navruz(Yakkatut)": "Navruz(Yakkatut)",
      "Istiqlol (1 May)": "Istiqlol (1 May)",
      "Vakhsh (Vahdat)": "Vakhsh (Vahdat)",
      "Dusti (Javoni)": "Dusti (Javoni)",
      "Mash'al (Senakos)": "Mash'al (Senakos)",
      "Tojikiston": "Tojikiston",
      "Tojikobod (Haqiqat)": "Tojikobod (Haqiqat)",
      "Vose TB Center": "Vose TB Center",
      "District HC Vose": "District HC Vose",
      "Ohchar": "Ohchar",
      "Bahoriston": "Bahoriston",
      "Kaduchi 1": "Kaduchi 1",
      "Kaduchi 3": "Kaduchi 3",
      "Sulhobod": "Sulhobod",
      "Fayzobod": "Fayzobod",
      "Guliston": "Guliston",
      "Kaftarhona": "Kaftarhona",
      "Toskala": "Toskala",
      "Shobika": "Shobika",
      "Zarkoron": "Zarkoron",
      "Selbur": "Selbur",
      "Sarichashma": "Sarichashma",
      "Hasan Kurbon": "Hasan Kurbon",
      "Gulobod": "Gulobod",
      "Navbahor": "Navbahor",
      "Kurboshaid 1": "Kurboshaid 1",
      "Gelot": "Gelot",
      "Darnaychi": "Darnaychi",
      "Kurboshaid 2": "Kurboshaid 2",
      "S.Sharif": "S.Sharif",
      "Gulrud": "Gulrud",
      "Pahtakor": "Pahtakor",
      "Istiqlol": "Istiqlol",
      "Voseobod": "Voseobod",
      "Homid barot": "Homid barot",
      "Tugarak": "Tugarak",
      "Javoni": "Javoni",
      "Navobod": "Navobod",
      "Chorbog": "Chorbog",
      "Zarkamar": "Zarkamar",
      "Kaduchi 2": "Kaduchi 2",
      "Pushyoni miyona": "Pushyoni miyona",
      "Hulbek": "Hulbek",
      "Zafarobod": "Zafarobod",
      "Rudaki": "Rudaki",
      "Anoriston": "Anoriston",
      "Kaynar": "Kaynar",
      "Dangara TB Center": "Dangara TB Center",
      "District HC Dangara": "District HC Dangara",
      "Tojmahal (Lohur)": "Tojmahal (Lohur)",
      "Hoja Shakiki Balhi (Sebiston)": "Hoja Shakiki Balhi (Sebiston)",
      "District HC Shamol dara (Gumsu)": "District HC Shamol dara (Gumsu)",
      "Bulyoni poyon": "Bulyoni poyon",
      "Guliston": "Guliston",
      "District HC Navobod": "District HC Navobod",
      "Gargara": "Gargara",
      "Mehtar (Sargaron)": "Mehtar (Sargaron)",
      "Chorsada": "Chorsada",
      "Osmon dara (Hachaguzar) ": "Osmon dara (Hachaguzar) ",
      "Sangtuda": "Sangtuda",
      "Dangarai bolo": "Dangarai bolo",
      "Hurramzamin (Jarteppa)": "Hurramzamin (Jarteppa)",
      "Bobotuphona": "Bobotuphona",
      "Bulyoni Bolo": "Bulyoni Bolo",
      "Fayzbahsh (Qushbuloq)": "Fayzbahsh (Qushbuloq)",
      "Safobahsh (Oqsu)": "Safobahsh (Oqsu)",
      "Malikova": "Malikova",
      "Pushing": "Pushing",
      "Alijon": "Alijon",
      "Gichovak": "Gichovak",
      "J.Balkhi TB Center": "J.Balkhi TB Center",
      "District HC balkhi": "District HC balkhi",
      "Navobod": "Navobod",
      "Qizil-Tojikiston": "Qizil-Tojikiston",
      "Uzun": "Uzun",
      "Sanoat": "Sanoat",
      "K-Marks": "K-Marks",
      "A.Dustov": "A.Dustov",
      "Lohuti": "Lohuti",
      "Leningrad": "Leningrad",
      "Toshrobod": "Toshrobod",
      "Isankulov": "Isankulov",
      "Guliston": "Guliston",
      "Hosilot": "Hosilot",
      "Frunze": "Frunze",
      "Sino": "Sino",
      "Ittifoq": "Ittifoq",
      "U.Namozov": "U.Namozov",
      "Kalenin": "Kalenin",
      "Dusti TB Center": "Dusti TB Center",
      "District HC Dusti": "District HC Dusti",
      "Nayson (Agronom)": "Nayson (Agronom)",
      "Ergash Sultonov": "Ergash Sultonov",
      "Markaz (Engels)": "Markaz (Engels)",
      "Istiqlol (Lebap)": "Istiqlol (Lebap)",
      "Dehqonobod": "Dehqonobod",
      "Qubodiyon": "Qubodiyon",
      "Achisel (Kuhdoman)": "Achisel (Kuhdoman)",
      "Shahrinav": "Shahrinav",
      "20 sol. Istiqloliyati Tojikiston (Garauti)": "20 sol. Istiqloliyati Tojikiston (Garauti)",
      "Eshbek Sattorov": "Eshbek Sattorov",
      "Dusti": "Dusti",
      "Buston": "Buston",
      "Gogol": "Gogol",
      "Komsomol": "Komsomol",
      "Qubodiyon TB Center": "Qubodiyon TB Center",
      "District HC Qubodiyon": "District HC Qubodiyon",
      "Alisher Navoi": "Alisher Navoi",
      "Pahtakor": "Pahtakor",
      "Arabhona": "Arabhona",
      "Ziraki": "Ziraki",
      "Avesto": "Avesto",
      "Chorqurgan": "Chorqurgan",
      "Vahdat (Qizil Ittifoq)": "Vahdat (Qizil Ittifoq)",
      "Oq-Oltin": "Oq-Oltin",
      "Farogat": "Farogat",
      "Tojikiston": "Tojikiston",
      "8-mart": "8-mart",
      "Kamarob": "Kamarob",
      "N.Husrav": "N.Husrav",
      "Qubodiyon": "Qubodiyon",
      "Chimgilish": "Chimgilish",
      "Uchqunobod": "Uchqunobod",
      "Jayhun TB Center": "Jayhun TB Center",
      "District HC Jayhun": "District HC Jayhun",
      "District HC - 1 (Hasanov)": "District HC - 1 (Hasanov)",
      "Lohuti-1": "Lohuti-1",
      "Vakhsh": "Vakhsh",
      "District HC № 2": "District HC № 2",
      "District HC № 8": "District HC № 8",
      "Sari pul": "Sari pul",
      "District HC № 3 (Rahmonov)": "District HC № 3 (Rahmonov)",
      "Orzu": "Orzu",
      "Eshhonov (District HC - 4)": "Eshhonov (District HC - 4)",
      "E.Mahmadov (District HC - 5)": "E.Mahmadov (District HC - 5)",
      "Hamadoni TB Center": "Hamadoni TB Center",
      "District HC Qabulgoh": "District HC Qabulgoh",
      "Gulobod": "Gulobod",
      "Dashtigulo": "Dashtigulo",
      "Darai kalot (Fayzali Saidov)": "Darai kalot (Fayzali Saidov)",
      "D. Halifaev": "D. Halifaev",
      "Dusti": "Dusti",
      "Davlatobod": "Davlatobod",
      "Mehnatobod": "Mehnatobod",
      "M. Rahimov": "M. Rahimov",
      "Margob": "Margob",
      "Oqmazor (Mehrvar)": "Oqmazor (Mehrvar)",
      "Pushkin": "Pushkin",
      "Safedob": "Safedob",
      "Sarhadchi": "Sarhadchi",
      "Sovetobod (Obshoron)": "Sovetobod (Obshoron)",
      "S. Turdiyev": "S. Turdiyev",
      "Tagnob": "Tagnob",
      "Hoja Mumin": "Hoja Mumin",
      "Muminobod TB Center": "Muminobod TB Center",
      "District HC Muminobod": "District HC Muminobod",
      "Shahri nav": "Shahri nav",
      "Gesh": "Gesh",
      "Momandiyon": "Momandiyon",
      "Kulchashma": "Kulchashma",
      "Sadbargoh": "Sadbargoh",
      "Hanatarosh": "Hanatarosh",
      "Sarmaydon": "Sarmaydon",
      "Tutqavul": "Tutqavul",
      "Dehlolo": "Dehlolo",
      "Ohjar (Navbahor)": "Ohjar (Navbahor)",
      "Dusti (Sarsibuloq)": "Dusti (Sarsibuloq)",
      "Boggai": "Boggai",
      "Chorbog (Chuqurqishloq)": "Chorbog (Chuqurqishloq)",
      "Langar": "Langar",
      "Tuto": "Tuto",
      "Momirak": "Momirak",
      "Bogi Habib": "Bogi Habib",
      "(Sh.Shohin) Tu-tu": "(Sh.Shohin) Tu-tu",
      "Sangdara": "Sangdara",
      "Qipchoq (Chashmasor)": "Qipchoq (Chashmasor)",
      "Shahrak": "Shahrak",
      "Dehibaland": "Dehibaland",
      "N.Hisrav TB Center": "N.Hisrav TB Center",
      "District HC N.Hisrav": "District HC N.Hisrav",
      "Kamsomol": "Kamsomol",
      "Orzu-1": "Orzu-1",
      "Voroshilov (Beshkapa)": "Voroshilov (Beshkapa)",
      "Beshkent-2 (Tulaganov)": "Beshkent-2 (Tulaganov)",
      "Norak TB Center": "Norak TB Center",
      "CHC Norak": "CHC Norak",
      "Dukoni": "Dukoni",
      "Tutqavul": "Tutqavul",
      "Langar": "Langar",
      "Panj TB Center": "Panj TB Center",
      "District HC Panj": "District HC Panj",
      "Orjonikidze": "Orjonikidze",
      "Komsomol": "Komsomol",
      "Safedorun": "Safedorun",
      "Turdi Shayh": "Turdi Shayh",
      "Madaniyat ": "Madaniyat ",
      "Nuri Vahdat (Tugul)": "Nuri Vahdat (Tugul)",
      "Kuldimon uch. Q-Yulduz": "Kuldimon uch. Q-Yulduz",
      "Kirov (Bedak)": "Kirov (Bedak)",
      "Somoni": "Somoni",
      "Namuna Peshqadam": "Namuna Peshqadam",
      "Pahtakor": "Pahtakor",
      "Dehbaland": "Dehbaland",
      "Temurmalik TB Center": "Temurmalik TB Center",
      "District HC Temurmalik": "District HC Temurmalik",
      "Kangurt": "Kangurt",
      "Safarboyon": "Safarboyon",
      "Chavroq": "Chavroq",
      "Dusti Shuluptu": "Dusti Shuluptu",
      "Boboyunus": "Boboyunus",
      "Bahoriston (Jantoqli)": "Bahoriston (Jantoqli)",
      "Tanobchi": "Tanobchi",
      "Qushqiya (L.Karmishev)": "Qushqiya (L.Karmishev)",
      "Vatan (S. Rahimov)": "Vatan (S. Rahimov)",
      "Davad": "Davad",
      "Farhor TB Center": "Farhor TB Center",
      "District HC Farhor": "District HC Farhor",
      "Vatan (Lenin)": "Vatan (Lenin)",
      "Kuhdoman (Mayda pata)  ": "Kuhdoman (Mayda pata)  ",
      "Sadoqat (Qizil mojir)": "Sadoqat (Qizil mojir)",
      "Kuhandiyori poyon (Orjonikidze)": "Kuhandiyori poyon (Orjonikidze)",
      "Lolazor": "Lolazor",
      "Haqiqat (Pravda)": "Haqiqat (Pravda)",
      "Kuhandiyori Bolo (Saksanohur)": "Kuhandiyori Bolo (Saksanohur)",
      "Sebi Surh": "Sebi Surh",
      "Gayrat (Dehqonariq)": "Gayrat (Dehqonariq)",
      "25 – solagii Tojikiston": "25 – solagii Tojikiston",
      "Zafar (40-solagii Tojikiston)": "Zafar (40-solagii Tojikiston)",
      "Archa": "Archa",
      "Shorqul": "Shorqul",
      "Bobosafoli poyon": "Bobosafoli poyon",
      "Alovudin": "Alovudin",
      "Hurramzamin (Tugul)": "Hurramzamin (Tugul)",
      "Gulshan": "Gulshan",
      "Mojirobod": "Mojirobod",
      "Darqad": "Darqad",
      "Mehrobod (Jayrali)": "Mehrobod (Jayrali)",
      "Galaba": "Galaba",
      "20 sol. Istiqloliyat  (Komsomol)": "20 sol. Istiqloliyat  (Komsomol)",
      "Navruz": "Navruz",
      "Hisor": "Hisor",
      "Qizil – su ": "Qizil – su ",
      "Surhob": "Surhob",
      "Hovaling Tb Center": "Hovaling Tb Center",
      "District HCC Hovaling": "District HCC Hovaling",
      "Vose": "Vose",
      "Dorobi": "Dorobi",
      "Chuqurak": "Chuqurak",
      "Darai Muhtor": "Darai Muhtor",
      "Tokak": "Tokak",
      "Lohuti": "Lohuti",
      "Sangrezgi": "Sangrezgi",
      "Obidara": "Obidara",
      "Zarkuh": "Zarkuh",
      "Halqayor": "Halqayor",
      "Navroho (Kuldara)": "Navroho (Kuldara)",
      "Chashmabedak": "Chashmabedak",
      "Sadbargo": "Sadbargo",
      "Chombaht": "Chombaht",
      "Sari-Osiyob ": "Sari-Osiyob ",
      "Safedshahrak": "Safedshahrak",
      "Gulzor": "Gulzor",
      "Zelolak": "Zelolak",
      "Sangdara": "Sangdara",
      "Shugnov": "Shugnov",
      "Huroson TB Center": "Huroson TB Center",
      "District HC Huroson": "District HC Huroson",
      "Jabbor Rasulov": "Jabbor Rasulov",
      "Tokparvar": "Tokparvar",
      "Nizomi": "Nizomi",
      "Mehnatobod-2": "Mehnatobod-2",
      "Jalolidini Rumi": "Jalolidini Rumi",
      "Alisher Navoi": "Alisher Navoi",
      "Tursun Uljaboev": "Tursun Uljaboev",
      "Achchi": "Achchi",
      "Mirzorahimov (Uyali)": "Mirzorahimov (Uyali)",
      "Chorbog": "Chorbog",
      "Qizil-Qala": "Qizil-Qala",
      "Mehnatobod-1": "Mehnatobod-1",
      "Shahritus TB Center": "Shahritus TB Center",
      "District HC Shahritus": "District HC Shahritus",
      "Ayvadj": "Ayvadj",
      "Iskra": "Iskra",
      "Pahtaobod": "Pahtaobod",
      "Mashinizatsiya (Ustokoron)": "Mashinizatsiya (Ustokoron)",
      "Sayod": "Sayod",
      "Hushodi": "Hushodi",
      "Tojikobod": "Tojikobod",
      "Birlash": "Birlash",
      "Hokak": "Hokak",
      "Obshoron": "Obshoron",
      "Sh.Shohin TB Center": "Sh.Shohin TB Center",
      "District HC Sh.Shohin": "District HC Sh.Shohin",
      "Zulmobod": "Zulmobod",
      "Devdor": "Devdor",
      "Dogiston": "Dogiston",
      "Shahribarbar": "Shahribarbar",
      "Darai Ob": "Darai Ob",
      "Kaftar": "Kaftar",
      "Chagam": "Chagam",
      "Sarichashma": "Sarichashma",
      "Yalabuli (Pistamazor)": "Yalabuli (Pistamazor)",
      "Yol": "Yol",
      "Porvor": "Porvor",
      "Hirmanjo": "Hirmanjo",
      "Dashtijum": "Dashtijum",
      "Langar": "Langar",
      "Navo": "Navo",
      "Yovon TB Center": "Yovon TB Center",
      "District HC Yovon": "District HC Yovon",
      "Chrmagzak": "Chrmagzak",
      "Dusti": "Dusti",
      "Shirinbuloq": "Shirinbuloq",
      "Ozodi": "Ozodi",
      "Charogchi": "Charogchi",
      "Dahana": "Dahana",
      "Garav": "Garav",
      "Gulsara Yusupova (Navkoram)": "Gulsara Yusupova (Navkoram)",
      "Dashtobod": "Dashtobod",
      "Tagoyobod": "Tagoyobod",
      "Qashqaraha": "Qashqaraha",
      "Qirgochak (Anoriston)": "Qirgochak (Anoriston)",
      "Qaynama": "Qaynama",
      "Parchasoy": "Parchasoy",
      "Rudaki": "Rudaki",
      "Navobodi - 4": "Navobodi - 4",
      "Furqat": "Furqat",
      "Hayoti-nav": "Hayoti-nav",
      "Hamza": "Hamza",
      "Sadi-Sherozi": "Sadi-Sherozi",
      "Urta-qaynar": "Urta-qaynar",
      "Pahtakor (Eshma)": "Pahtakor (Eshma)",
      "Bosh-qaynar": "Bosh-qaynar",
      "Bahor": "Bahor",
      "Shurcha": "Shurcha",
      "Gulafshon": "Gulafshon",
      "Qulobod": "Qulobod",
      "Buston-2": "Buston-2",
      "Guliston Kunchi+buston-1": "Guliston Kunchi+buston-1"

    }
  },
  "tg": {
    "translation": {
      "Upload": "Бор кунед",
      "Dashboard": "Панели асбобҳо",
      "Prevent TB - Tajikistan": "Prevent TB - Тоҷикистон",
      "home": "Асосӣ",
      "Line List": "Рӯйхат",
      "Alerts": "Огоҳӣ",
      "Smart Setup": "Setup Smart",
      "Users": "Истифодабарандагон",
      "Index Upload": "Боркунии индекс",
      "QR Code": "QR код",
      "QR Code Generation": "Сохтани QR код",
      "Logout": "Баромад",
      "Reset ": "Бозсозии танзимот",
      "Index registered": "Шумораи индекс ба қайд гирифта шуда",
      "Key population Registered": "Гуруҳи калидии аҳолӣ (ба қайд гирифта шуда)",
      "Contact registered": "Алоқамандони ба қайд гирифта шуда",
      "Contact screened": "Алоқамандони скрининг шуда",
      "Referred to Investigation - TB": "Ба тафтишот фиристода шудааст - Сил",
      "Referred to Investigation - LTBI": "Ба тафтишот фиристода шудааст - Сили ниҳонӣ (СНС)",
      "TB Negative": "Сил манфӣ",
      "TB Postive": "Сил мусбӣ",
      "LTBI Negative": "Сили ниҳонӣ (СНС) манфӣ",
      "LTBI Positive": "Сили ниҳонӣ (СНС) мусбӣ",
      "Total registered - Index and Contact": "Ҳамагӣ ба қайд гирифта шуда - Индекс ва Алоқамандон",
      "TB and LTBI cases": "Ҳодисаҳои сироятиСил ва Сили Ниҳонӣ (СНС)",
      "TB testing - Positive": "Ташхиси сил - мусбӣ",
      "LTBI testing - Positive": "Ташхиси сили ниҳонӣ - мусбӣ",
      "Gender": "ҶИНС",
      "Reset Map": "Бозсозии харита",
      "Gender (male)": "Ҷинс (мард)",
      "Gender (female)": "Ҷинс (зан)",
      "Gender (TG)": "Ҷинс (TG)",
      "Hotspot Details": "Тафсилоти нуқтаи дастрас",
      "Select Filter": "Филтрро интихоб кунед",
      "Organisation Units": "Муассисаҳо",
      "Tajikistan": "Тоҷикистон",
      "Period": "Давра",
      "Period Type": "Намуди давра",
      "Select Period Type": "Намуди давра",
      "Yearly": "Ҳамасола",
      "Apply": "Сабт",
      "Powered By": null,
      "null": null,
      "All": "Ҳама",
      "Index": "Индекс",
      "Contact": "Тамос",
      "Key Population": "Аҳолии калидӣ",
      "Search": "Ҷустуҷӯ",
      "Cases": "Ҳолатҳо",
      "Page": "Саҳифаи",
      "Go to page": "Ба саҳифа равед",
      "Show": "Намоиш",
      "Export Data": "Содироти маълумот",
      "UIC": "UIC",
      " Name": "НОМ",
      "Name": "НОМ",
      "District": "Ноҳия",
      "Mobile Number": "Рақами телефони мобилӣ",
      "Age (in years)": "СИННУ",
      "Observation Type": "Навъи мушоҳида",
      "Presently on anti-TB medication?": "АЙНИ ҲОЛ ДОРУИ ЗИДДИ СИЛ ИСТЕЪМОЛ МЕКУНАД.",
      "ALERTS": "ОГОҲИНОМА",
      "Threshold Value": "Арзиши ҳадди",
      "Days": "Рузҳо",
      "No Data": "Маълумот мавҷуд нест",
      "Enter Number of QR Codes to be Generated": "Шумораи рамзҳои QR-ро барои тавлид ворид кунед",
      "Generate": "Тавлид",
      "Leaflet": "Варақа",
      "N/A": "Номаълум",
      "of": "аз",
      "Registered By": "БА ҚАЙД ГИРИФТА ШУД АЗ ҶОНИБИ",
      "Select Role": "Нақшро интихоб кунед",
      "Select User": "Корбарро интихоб кунед",
      "Select Organisation Unit": "Воҳиди муассисаро интихоб кунед",
      "Select Municipality": "Минтақаро интихоб кунед",
      "Select CHC": "Ноҳияро интихоб кунед",
      "Select Block": "Муассисаро интихоб кунед",
      "Enter Number of QR Codes to be Generated": "Шумораи рамзҳои QR-ро барои ташкил кардан ворид кунед",
      "Generate QR Code": "Сохтани QR код",
      "Age": "СИННУ СОЛ",
      "Are you sure you want to logout?": "Шумо мехоҳед аз система хориҷ шавед?",
      "& Above": "& Боло",
      "Yes": "Ҳа",
      "No": "Не",
      "Date Range": "Даври сана",
      "Monthly": "Моҳона",
      "Quarterly": "Ҳар семоҳа",
      "Yearly": "Солона",
      "No Alerts": "Огоҳӣ нест",
      "records": "records",
      "Details": "Тафсилот",
      "Treatment Initiation": "Оғози табобат",
      "Select": "интихоб кардан",
      "All Rights Reserved" : "Ҳамаи ҳуқуқ маҳфуз аст",
      "Quarter 1(Jan-Mar)" : "Семоҳаи 1 (январ-март)",
      "Quarter 2(Apr-Jun)" : "Семоҳаи 2 (апрел-июнь)",
      "Quarter 3(Jul-Sep)" : "Семоҳаи 3 (июл-сентябр)",
      "Quarter 4(Oct-Dec)" : "Семоҳаи 4 (октябр-декабр)",
      // ORG LABEL.............................................................................................................................................
      "РРП": "НТМ",
      "Сугд": "Суғд",
      "Хатлон": "Хатлон",
      "GBAO": "ВХКБ",
      "Dushanbe": "Душанбе",
      "Rudaki": "Рӯдакӣ",
      "Vahdat": "Ваҳдат",
      "Varzob": "Варзоб",
      "Hisor": "Ҳисор",
      "Lahsh": "Лахш",
      "Nurobod": "Нуробод",
      "Rasht": "Рашт",
      "Rogun": "Рогун",
      "Sangvor": "Сангвор",
      "Tojikobod": "Тоҷикобод",
      "Tursunzoda": "Турсунзода",
      "Fayzobod": "Фйзобод",
      "Shahrinav": "Шаҳринав",
      "Khujand": "Хуҷанд",
      "Guliston": "Гулистон",
      "Istiqlol": "Истиқлол",
      "Buston": "Бустон",
      "Ayni": "Айни",
      "Asht": "Ашт",
      "B.Gafurov": "Б.Гафуров",
      "Devashtich": "Деваштич",
      "Kuhistoni Mastchoh": "Кӯҳистони Масчоҳ",
      "J.Rasulov": "Ҷ.Расулов",
      "Zafarobod": "Зафаробод",
      "Istaravshan": "Истарафшан",
      "Isfara": "Исфара",
      "Konibodom": "Конибодом",
      "Mastchoh": "Масчоҳ",
      "Panjakent": "Панҷакент",
      "Spitamen": "Спитамен",
      "Shahriston": "Шаҳристон",
      "Bokhtar": "Бохтар",
      "Kulob": "Кулоб",
      "Levakant": "Левакант",
      "A.Jomi": "А. Ҷомӣ",
      "Baljuvon": "Балҷувон",
      "Kushoniyon": "Кушониён",
      "Vahsh": "Вахш",
      "Vose": "Восеъ",
      "Dangara": "Данғара",
      "J.Balkhi": "Ҷ.Балхӣ",
      "Dusti": "Дӯстӣ",
      "Qubodiyon": "Қубодиён",
      "Jayhun": "Ҷайҳун",
      "Hamadoni": "Ҳамадонӣ",
      "Muminobod": "Муъминобод",
      "N.Hisrav": "Н.Хисрав",
      "Norak": "Норак",
      "Panj": "Панҷ",
      "Temurmalik": "Темурмалик",
      "Farhor": "Фархор",
      "Hovaling": "Ховалинг",
      "Huroson": "Хуросон",
      "Shahritus": "Шаҳритус",
      "Sh.Shohin": "Ш. Шоҳин",
      "Yovon": "Ёвон",
      "Khorug": "Хоруғ",
      "Vanj": "Ванҷ",
      "Darvoz": "Дарвоз",
      "Ishkoshim": "Ишкошим",
      "Murgob": "Мурғоб",
      "Roshqala": "Рошқалъа",
      "Rushon": "Рушон",
      "Shugnon": "Шуғнон",
      "PHC №2": "МСШ №2",
      "PHC №3": "МСШ №3",
      "PHC №4": "МСШ №4",
      "PHC №5": "МСШ №5",
      "PHC №6": "МСШ №6",
      "PHC №7": "МСШ №7",
      "PHC №8": "МСШ №8",
      "PHC №9": "МСШ №9",
      "PHC №10": "МСШ №10",
      "PHC №11": "МСШ №11",
      "PHC №12": "МСШ №12",
      "PHC №1": "МСШ №13",
      "PHC №14": "МСШ №14",
      "PHC №15": "МСШ №15",
      "Zaynabobod": "Зайнабобод",
      "Russia": "Русия",
      "Rohati": "Рохатй",
      "Qiblai": "Қиблай",
      "Guliston ": "Гулистон",
      "Sultonobod": "Султонобод",
      "Somoniyon": "Сомониён",
      "Esanboy": "Эсанбой",
      "Chorgulteppa": "Чоргултеппа",
      "Lohur": "Лохур",
      "Ishkobod": "Ишкобод",
      "Chimteppa": "Чимтеппа",
      "Sarikishti": "Сарикишти",
      "Navobod": "Навобод",
      "Chorteppa": "Чортеппа",
      "Choryakkaron": "Чоряккорон",
      "DOTS 2": "Ҳуҷраи DOT 2",
      "DOTS 3": "Ҳуҷраи DOT 3",
      "RHC Romit": "МСД Ромит",
      "Yavroz": "Явроз",
      "Hushon": "Хушон",
      "Sayod": "Сайёд",
      "Vistan": "Вистан",
      "Tvishi poyon": "Твиши пойён",
      "Sorvo": "Сорво",
      "Loshharf": "Лошхарф",
      "Varva": "Варва",
      "Yafrak": "Яфрак",
      "RHC Tangay": "МСД Tangay",
      "RHC Lichak": "МСД Личак",
      "Shorazm": "Шоразм",
      "Chuyangaron": "Чуянгарон",
      "Hordara": "Хордара",
      "RHC Amonshayhi": "МСД Амоншайҳи",
      "Shahdrez": "Шахдрез",
      "RHC Chorbog": "МСД Чорбог",
      "Yums ": "Юмс",
      "RHC Bakaron": "МСД Бакарон",
      "Shabgardi": "Шабгарди",
      "RHC Simiganj": "МСД Симиганҷ",
      "RHC Firishti": "МСД Фиришти",
      "Arbobi": "Арбоби",
      "Panjikon": "Панҷикон",
      "Odily": "Одилона",
      "Sarchinor": "Сарчинор",
      "RHC navruz": "МСД навруз",
      "RHC Kipchok": "МСД Кипчок",
      "Nozirobod": "Нозиробод",
      "RHC Hojikatagan": "МСД Хочикатагон",
      "Guliston ": "Гулистон",
      "Zafarobod": "Зафаробод",
      "Machiton": "Мачитон",
      "Gulbog": "Гулбог",
      "RHC Kamongaron": "МСД Камонгарон",
      "RHC Bahor": "МСД Бахор",
      "Pistamazor": "Пистамазор",
      "RHC Guliston": "МСД Гулистон",
      "Dahana": "Дахана",
      "Hirgatarosh": "Хиргатарош",
      "Dehqonobod": "Дехконобод",
      "RHC Tilloi safed": "МСД Тиллои сафед",
      "Jarteppa": "^артеппа",
      "Kuhdoman": "Куҳдоман",
      "RHC Buston": "МСД Бустон",
      "Kishovarz": "Кишоварз",
      "Hakikat": "Хакикат",
      "Jangalobod": "Чангалобод",
      "Adolat": "Адолат",
      "RHC Mehrbahsh": "МСД Mehrbahsh",
      "Abdurasuli": "Абдурасулй",
      "Madaniyat-1": "Маданият-1",
      "Navbahor": "Навбахор",
      "Istiqloliyat": "Истиқлолият",
      "Surhchashma": "Сурхчашма",
      "Madaniyat-2": "Маданият-2",
      "RHC Ganjbor": "МСД Ганҷбор",
      "Sitorai surh": "Ситораи сурх",
      "Charboshi": "Чарбошй",
      "RHC Dusti": "МСД Дустй",
      "Muminobod": "Муъминобод",
      "RHC Qarsang": "МСД Қарсанг",
      "Buzbit": "Бузбит",
      "RHC Navobod": "МСД Навобод",
      "Mehnatobod": "Мехнатобод",
      "RHC Boston": "МСД Бостон",
      "Arbobdara": "Арбобдара",
      "Naydara": "Найдара",
      "Sangpar": "Сангпар",
      "Sugdiyon": "Сугдиён",
      "Gurghurda": "Гургурда",
      "Holmurodi": "Холмуродй",
      "RHC Bahoriston": "МСД Баҳористон",
      "Zardolu": "Зардолу",
      "Qalai mali": "Қалъаи Мали",
      "Yalanchinor": "Яланчинор",
      "Chepisoleh": "Чеписолех",
      "Gulakandoz": "Гулакандоз",
      "Galchari": "Галчари",
      "Geshi": "Геши",
      "RHC B.Burunov": "МСД Б.Бурунов",
      "Fayzbahsh": "Файзбахш",
      "Mehrobod": "Мехробод",
      "RHC Girdob": "МСД Гирдоб",
      "Chirtak": "Чиртак",
      "RHC Shifo": "МСД Шифо",
      "Javonon": "Ҷавонон",
      "Shirinchashma": "Ширинчашма",
      "Zarteppa": "Зартеппа",
      "RHC Solehon": "МСД Солехон",
      "Sarchashma": "Сарчашма",
      "Zulfi": "Зулфи",
      "Sufiyon": "Суфиён",
      "RHC Gulrez": "МСД Гулрез",
      "Andigon": "Андигон",
      "Ganjina": "Ганҷина",
      "RHC Chillamazor": "РКЧ Чилламазор",
      "Sharifobod": "Шарифобод",
      "Zargar": "Заргар",
      "Mehrgon": "Мехргон",
      "RHC Kofarnihon": "РКД Кофарнихон",
      "Chinor": "Чинор",
      "Dashtibedi kalon": "Даштибеди калон",
      "Dashtibedi hurd": "Хурд Даштибеди",
      "Elovar": "Эловар",
      "Obidara": "Обидара",
      "Chaman": "Чаман",
      "Bahoriston": "Баҳористон",
      "Hisor TB Center": "Маркази бемории сил Ҳисор",
      "Almosi": "Алмосй",
      "Bobosurhon": "Бобосурхон",
      "Vatan": "Ватан",
      "Guli surh": "Гули сурх",
      "Gulhani": "Гулхани",
      "Gayratobod": "Гайратобод",
      "Guriyot": "Гуриёт",
      "Dehqonobod": "Дехконобод",
      "Durbat": "Дурбат",
      "Duchinora": "Дучинора",
      "Iskich": "Искич",
      "Kavshduzon": "Кавшдузон",
      "Dahbed": "Даҳбед",
      "Mehrobod": "Мехробод",
      "Niyogon": "Ниёгон",
      "Mehrgon": "Мехргон",
      "Lolagi": "Лолаги",
      "Morteppa": "Мортеппа",
      "Navobod": "Навобод",
      "Nilu": "Нилу",
      "Nochi-bolo": "Ночи боло",
      "Oybosh": "Ойбош",
      "Sumbula": "Сумбула",
      "Sangchashma": "Сангчашма",
      "Tuda": "Туда",
      "Uzbekiston": "Узбекистон",
      "Hayotinav": "Хаётинав",
      "Honakoi Kuhi": "Хонакой Куҳи",
      "Hiloli Ahmar": "Хилоли Ахмар",
      "Hisor": "Хисор",
      "Sugdiyon": "Сугдиён",
      "Javoni": "Чавонй",
      "Halkarud": "Халкаруд",
      "Sharora": "Шарора",
      "Nurafshon": "Нурафшон",
      "Tursunzoda TB Center": "Маркази бемории сили Турсунзода",
      "Durbent": "Дурбент",
      "Dusti": "Дустй",
      "Kommunizm": "Коммунизм",
      "Quzi-bacha": "Қузи-бача",
      "Leninizm": "Ленинизм",
      "Moskva": "Москва",
      "Pahtashirkat": "Пахташиркат",
      "Pahtakor": "Пахтакор",
      "Pravda": "«Правда».",
      "Sarkor": "Саркор",
      "Toychi": "Тойчй",
      "Husnobod": "Хуснобод",
      "Chkalov": "Чкалов",
      "Pahtaobod": "Пахтаобод",
      "Yangiturmush": "Янгитурмуш",
      "Efiranos": "Эфиранос",
      "Devak": "Девак",
      "Beshteppa": "Бештеппа",
      "Chinor": "Чинор",
      "Qaratog": "Қаратоғ",
      "Qizil-nishon": "Қизил-нишон",
      "Kalinin": "Калинин",
      "Frunze": "Фрунзе",
      "Oqtosh": "Октош",
      "Batosh": "Батош",
      "Guliston ": "Гулистон",
      "Oqtelpak": "Октелпак",
      "Istiqlol": "Истиқлол",
      "Shahrinav TB Center": "Маркази бемории сил Шаҳринав",
      "Navobod": "Навобод",
      "Qadi juybor": "Қоди ҷуйбор",
      "Shurob": "Шуроб",
      "Istiqlol": "Истиқлол",
      "Pahtakor": "Пахтакор",
      "Bahoriston": "Баҳористон",
      "Chust": "Чуст",
      "Uzun": "Узун",
      "Dehobod": "Дехобод",
      "Eloki": "Элоки",
      "Sangala": "Сангала",
      "Tojikistan": "Тоҷикистон",
      "Bogiston": "Богистон",
      "Dolon": "Долон",
      "Ajam": "Аҷам",
      "Akram Hasan": "Акрам Хасан",
      "Muloshodi": "Мулошоди",
      "M.Tursunzoda": "Турсунзода М",
      "Khujand TB Center": "Маркази бемории сил Хуҷанд",
      "CHC №1 Khujand": "МСШ №1 Хуҷанд",
      "CHC №2 Khujand": "МСШ №2 Хуҷанд",
      "CHC №3 Khujand": "МСШ №3 Хуҷанд",
      "CHC №4 Khujand": "МСШ №4 Хуҷанд",
      "CHC №5 Khujand": "МСШ №5 Хуҷанд",
      "Guliston TB Center": "Маркази бемории сил Гулистон",
      "CHC Qayroqum": "МСШ Қайроқум",
      "Adrasmon": "Адрасмон",
      "Zarnisor": "Зарнисор",
      "Konsoy": "Консой",
      "Sirdaryo": "Сирдарё",
      "Choruqdarron": "Чорукдаррон",
      "Navgarzan": "Навгарзан",
      "Istiqlol TB Center": "Маркази мубориза бо бемории сил Истиқлол",
      "CHC Istiqlol": "МСШ Истиклол",
      "Buston TB Center": "Маркази бемории сил Бӯстон",
      "CHC Buston": "МСШ Бустон",
      "Ayni TB Center": "Маркази бемории сил Айнӣ",
      "District HC Ayni": "МСШ Айнй",
      "Aslonobod": "Аслонобод",
      "Veshab": "Вешаб",
      "Veshkand": "Вешканд",
      "Darg": "Дарг",
      "Dardar": "Дардор",
      "Kum": "Кум",
      "Zerabod": "Зеробод",
      "Zoosun": "Зоосун",
      "Madm": "Мадм",
      "Pohut": "Похут",
      "Rarz": "Рарз",
      "Revad": "Ревад",
      "Urmetan": "Урметан",
      "Shavadki bolo": "Шавадки боло",
      "Shamtuch": "Шамтуч",
      "District HC №1 Zarafshon": "МСН №1 Зарафшон",
      "Tagi Chinor": "Таги Чинор",
      "Gaberut": "Габерут",
      "Mahshevad": "Махшевад",
      "Dijik": "Дижик",
      "Asht TB Center": "Маркази бемории сил Ашт",
      "District HC Shaydon": "МСН Шайдон",
      "Bobokir": "Бобокир",
      "Makarenko": "Макаренко",
      "Dusti": "Дустй",
      "Asht": "Ашт",
      "Oriyon": "Ориён",
      "Qamishqurgan": "Қамишқӯрғон",
      "Djigda": "Ҷидда",
      "Iftihor": "Ифтихор",
      "Marhamat": "Мархамат",
      "Appon": "Аппон",
      "Oshoba": "Ошоба",
      "Sudja": "Судя",
      "Saro": "Саро",
      "Bobodarhon": "Бободархон",
      "Pushta": "Пушта",
      "Pongoz": "Понгоз",
      "Punuk": "Пунук",
      "Gulshan": "Гулшан",
      "B.Gafurov TB Center": "Маркази мубориза бо сил ба Б.Ғафуров",
      "District HC B.Gafurov": "МСН Б. Гафуров",
      "Qistakoz": "Қистакоз",
      "Histavers": "Хистеварз",
      "Zarzamin": "Зарзамин",
      "Tojikistan": "Тоҷикистон",
      "A.Sattorov": "А.Сатторов",
      "Kintirik": "Кинтирик",
      "Yava": "Ёва",
      "Toshloq": "Тошлоқ",
      "Sirdaryo": "Сирдарё",
      "H.Usmon": "Х.УСМОН",
      "Odil": "Одил",
      "Undji": "Унджи",
      "Dashtak": "Даштак",
      "Isfisor": "Исфисор",
      "Hodjent": "Ходжент",
      "Dashti Amin": "Дашти Амин",
      "Ismoil": "Исмоил",
      "Baht": "Бат",
      "Qizil Yulduz": "Қизил Юлдуз",
      "Ovuchi kalacha": "Овучи калача",
      "Kulangir": "Кулангир",
      "Utkansoy": "Уткансой",
      "Oktepa": "Октеппа",
      "Gaziyan": "Газиён",
      "Chorsu": "Чорсу",
      "Kotma": "Котма",
      "Vodnik": "Водник",
      "Bogparvar": "Богпарвар",
      "Devashtich TB Center": "Маркази бемории сил Деваштич",
      "District HC Devashtich": "МСН Деваштич",
      "District HC №1 Kalininobod": "МСН № 1 Калининобод",
      "Lolazor": "Лолазор",
      "Hushtoiri Muhlon": "Хуштоири Мухлон",
      "Zarnisor": "Зарнисор",
      "Muchun": "Мучун",
      "Nurobod": "Нуробод",
      "Istiqlol": "Истиқлол",
      "hazorchashma": "хазорчашма",
      "Surhob": "Сурхоб",
      "Basmanda": "Басманда",
      "Ovchi": "Овчи",
      "Dahkat": "Дахкат",
      "Hishekat": "Хишекат",
      "Rosrovut": "Росровут",
      "Metk": "Метк",
      "Dalyani Bolo": "Даляни Боло",
      "Dalyani poyon": "Даляни поён",
      "Kuhistoni Mastchoh TB Center": "Маркази мубориза бар зидди бемории сили Кӯҳистони Мастчоҳ",
      "District HC Kuhistoni Mastchoh": "МСН Куҳистони Мастчох",
      "Madrushkat": "Мадрушкат",
      "Pastigav": "Пастигав",
      "Revomutk": "Ревомутк",
      "Rog": "Рог",
      "Esiz": "Эсиз",
      "Regional TB Center Dehmoy": "Маркази вилоятии мубориза бар зидди бемории сил Дехмой",
      "District HC J.Rasulov": "МСН Ч. Расулов",
      "4-um Mahlla": "4-ум Маҳалла",
      "Guliston": "Гулистон",
      "Yangiqishloq": "Янгиқишлоқ",
      "Yangiobod": "Янгиобод",
      "Qurgoncha": "Кургонча",
      "Gulhona": "Гулхона",
      "Gulyakindoz": "Гулякиндоз",
      "Dehmoy": "Дехмой",
      "Zarafshon": "Зарафшон",
      "Parij Kommuna": "Париж Коммуна",
      "Tojikobod": "Тоҷикобод",
      "Uzbekqishloq": "Узбекқишлоқ",
      "Yangiqadam": "Янгикадам",
      "Zafarobod TB Center": "Маркази мубориза бо сили Зафаробод",
      "CHC Zafarobod": "МСШ Зафаробод",
      "Baht": "Бат",
      "Guliston": "Гулистон",
      "Hayoti Nav": "Ҳаёти нав",
      "Hamid Aliyev": "Хамид Алиев",
      "Login": "Даромадан",
      "Mehnatobod": "Мехнатобод",
      "Jomi": "Ҷомӣ",
      "Zarafshon (Komsomol)": "Зарафшон (Комсомол)",
      "Istaravshan TB Center": "Маркази мубориза бар зидди бемории сил дар Истаравшан",
      "HC №1": "Маркази саломатии №1",
      "HC №2": "Маркази саломатии №2",
      "Bobotago": "Боботаго",
      "Bogkalon": "Богкалон",
      "Varsi": "Варсй",
      "Vogat": "Вогат",
      "Qalai baland": "Қалъаи баланд",
      "Qalachai kalon": "Калъачаи калон",
      "Kurushkada": "Курушкада",
      "lakat": "лакат",
      "Mahallai Yasi": "Маҳаллаи Яси",
      "Nijoni": "Ниҷонӣ",
      "Nofaroj": "Нофарож",
      "Obodi": "Ободи",
      "Rugund": "Ругунд",
      "Orif": "Ориф",
      "Toshbek": "Тошбек",
      "Chavkandak": "Чавкандак",
      "Chorqurgon": "Чоркургон",
      "Chorbosh": "Чорбош",
      "Yakkabosh": "Яккабош",
      "Isfara TB Center": "Маркази бемории сил дар Исфара",
      "CHC Isfara": "МСШ Исфара",
      "Navgilem": "Навгилем",
      "Oftobru": "Офтобру",
      "Kulkent": "Кулкент",
      "Chilgizi": "Чилгизй",
      "Lakkon": "Лаккон",
      "Neftobod": "Нефтобод",
      "Zarkuh": "Заркуҳ",
      "Nurafshon": "Нурафшон",
      "Matpari": "Матпари",
      "Chorqishloq": "Чорқишлоқ",
      "Surh": "Сурх",
      "Chorkuh": "Чоркуҳ",
      "Voruh": "Ворух",
      "Honaobod": "Хонаобод",
      "Saridasht": "Сардашт",
      "Tidon": "Тидон",
      "Shurob": "Шуроб",
      "Hojai Alo": "Хоҷаи Аъло",
      "Konibodom TB Center": "Маркази бемории сили Конибодом",
      "CHC Konibodom": "МСШ Конибодом",
      "Niyozbek": "Ниёзбек",
      "Mahram": "Маҳрам",
      "Hamroboev": "Хамробоев",
      "Hamirjuy": "Хамирчуй",
      "Ortiqov": "Ортиков",
      "Dilovaron (Shaitkaroyan)": "Диловарон (Шайткароян)",
      "Shurqurgon": "Шуркургон",
      "Zarbed": "Зарбед",
      "Kuruk": "Курук",
      "Puloton": "Пулотон",
      "Ravot": "Равот",
      "Patar": "Патар",
      "Galaba": "Галаба",
      "Dusti (Assor)": "Дӯстӣ (Асор)",
      "Jahonzeb (Qaraqchiqum)": "Ҷаҳонзеб (Қарачиқум)",
      "Lohuti": "Лоҳутӣ",
      "Mastchoh TB Center": "Маркази бемории сили Мастчох",
      "District HC Mastchoh": "МСН Мастчох",
      "J.Mastchoh": "Ҷ.Мастчоҳ",
      "Azizobod (M.Komsomoli)": "Азизобод (М. Комсомол)",
      "J.Obburdon ": "Ҷ.Оббурдон",
      "Fayz Sulton": "Файз Султон",
      "J.Paldorak ": "Ҷ.Палдорак",
      "J.Avzikent (Navbahor)": "Ҷ.Авзикент (Навбаҳор)",
      "J.Kuruksoy Obshoron": "Ҷ.Қуруксой Обшорон",
      "Panjakent TB Center": "Маркази мубориза бар зидди бемории сил дар шаҳри Панҷакент",
      "CHC Panjakent": "МСШ Панчакент",
      "Hurmi": "Хурмй",
      "Ozodagon": "Озодагон",
      "Shingak": "Шингак",
      "Voru": "Вору",
      "Ruknobod": "Рукнобод",
      "Porven": "Порвен",
      "Maykatta": "Майкатта",
      "Amondara": "Амондара",
      "Ravot": "Равот",
      "Navruzteppa": "Наврузтеппа",
      "Shurcha": "Шурча",
      "Sangi kabud": "Санги кабуд",
      "Farob": "Фароб",
      "Sarazm": "Саразм",
      "CHC Sarazm": "МСШСаразм",
      "Shurnova": "Шурнова",
      "Childara": "Чилдара",
      "Chimqala": "Чимқалъа",
      "Mazor": "Мазор",
      "Gusar": "Гусар",
      "Navobod": "Навобод",
      "Dashto Qozi": "Дашто Қозӣ",
      "Mindona": "Миндона",
      "Yori": "Ёри",
      "Kuloli": "Кулоли",
      "Artuch": "Артух",
      "Panjrud": "Панҷрӯд",
      "Negnot": "Беэътиноӣ",
      "Margedar": "Маргедар",
      "Dasht": "Дашт",
      "Qumsoy": "Қумсой",
      "Suchina": "Сучина",
      "Filmandar": "Филмандар",
      "Kosatarosh": "Косатарош",
      "Sogdiana": "Суғдиёна",
      "Chorbog": "Чорбог",
      "Mogiyon": "Могиён",
      "Sor": "Сор",
      "Gezan": "Гезан",
      "Shing": "Шинг",
      "Toshmunor": "Тошмунор",
      "Spitamen TB Center": "Маркази бемории сил Спитамен",
      "District HC №1 Spitamen": "МСН №1 ноҳияи Спитамен",
      "District HC №2 Spitamen": "МСН №2 ноҳияи Спитамен",
      "hurramzamin": "хуррамзамин",
      "Oktepa": "Октеппа",
      "Havatag": "Хаватог",
      "Yangtobod": "Янгтобод",
      "Qushtegirmon": "Қуштегирмон",
      "Saidkurgon": "Саидкургон",
      "Togoyak": "Тогояк",
      "Langar": "Лангар",
      "Shahriston TB Center": "Маркази бемории сил Шаҳристон",
      "District HC Shahriston": "МСН райони Шаҳристон",
      "Obodi": "Ободи",
      "Sebzor": "Себзор",
      "Bokhtar TB Center": "Маркази мубориза бар зидди бемории сил Бохтар",
      "CHC Bokhtar": "МСШ Бохтар",
      "Child HC Bokhtar": "МС Кӯдакон Бохтар",
      "Sarchashma (Nihi)": "Сарчашма (Нихи)",
      "Gayrat": "Гайрат",
      "Hayoti Nav": "Ҳаёти нав",
      "Zarbdor": "Зарбдор",
      "Kulob TB Center": "Маркази мубориза бар зидди бемории сил дар Кӯлоб",
      "Regional HC Kulob": "МСН Кулоб",
      "District HC Kulob": "МСН Кулоб",
      "Honobod": "Хонобод",
      "Dahana": "Дахана",
      "Saryozii bolo": "Сарёзии боло",
      "Ziraki": "Зираки",
      "Aftobluk": "Афтоблук",
      "Hakimobod": "Хакимобод",
      "Lagmon": "Лағмон",
      "Chorbog": "Чорбог",
      "Khatlon": "Хатлон",
      "Panjosiyob": "Панҷосиёб",
      "CHC №1 Kulyab": "МСШ №1 Кӯлоб",
      "CHC №2 Kulyab": "МСШ №2 Кӯлоб",
      "Child HC Kulyab": "МС Кудакон Кулоб",
      "Levakant Tb Center": "Маркази тиб Левакант",
      "CHC Sarband": "МСШ Сарбанд",
      "Bohturobod": "Бохтуробод",
      "Guliston": "Гулистон",
      "Okgaza №1": "Окгаза №1",
      "Kuli Sufiyon": "Кули Суфиён",
      "A.Jomi TB Center": "Маркази мубориза бо бемории сил ба номи А",
      "District HC A.Jomi": "МСН ноҳияи А.Ҷомӣ",
      "Bahor": "Бахор",
      "Dusti (Yakkatut)": "Дӯстӣ (Яккатут)",
      "Tojikiston": "Тоҷикистон",
      "Lenin (Qadridin Giyosov)": "Ленин (Қадридин Гиёсов)",
      "Kalenin (Gulobod)": "Каленин (Гулобод)",
      "Galaba": "Галаба",
      "Mehnat": "Мехнат",
      "Baljuvon TB Center": "Маркази бемории сил Балҷувон",
      "District HC Baljuvon": "МСН Нохияи Балҷувон",
      "RHC Oqbuloq": "МСД Оқбулоқ",
      "RHC Sari hosor (Shahidon)": "МСД Сари хосор (Шаҳидон)",
      "Hoirob": "Хойроб",
      "Sari mazor": "Сари мазор",
      "Chorbog": "Чорбог",
      "Sulmolidasht": "Сулмолидашт",
      "Navbahor (Satalmush)": "Навбаҳор (Саталмуш)",
      "Zarnisor (Dektur)": "Зарнисор (Дектур)",
      "Dashti Maydon": "Дашти Майдон",
      "Guldara": "Гулдара",
      "Shingidara": "Шинидара",
      "Kushoniyon TB Center": "Маркази мубориза бар зидди бемории сил Кушониён",
      "District HCC Kushoniyon": "МСН райони Кушониён",
      "Voroshilov": "Ворошилов",
      "Zargar": "Заргар",
      "Komsomol": "комсомолй",
      "Pahtakor": "Пахтакор",
      "F.Saidov 3": "Ф.Саидов 3",
      "1-department": "1-кафедра",
      "4-department": "4-кафедра",
      "Navobod": "Навобод",
      "Urtabuz": "Уртабуз",
      "Sarvati Istiqlol": "Сарвати Истиқлол",
      "Lenin": "Ленин",
      "Sverdlov": "Свердлов",
      "Navkor": "Навкор",
      "Marksizm": "Марксизм",
      "Chorsu": "Чорсу",
      "Istiqlol": "Истиқлол",
      "S. Ayni": "Айнй С",
      "Navbahor": "Навбахор",
      "Buston-Qal'a": "Бустон-Қалъа",
      "SMP-540": "SMP-540",
      "Sabzavot": "Сабзавот",
      "Rohi Lenin": "«Рохи Ленин».",
      "Mehnatobod": "Мехнатобод",
      "Vakhsh TB Center": "Маркази бемории сил дар Вахш",
      "District HCC Вахш": "МСН Вахш",
      "Rudaki": "Рӯдакӣ",
      "Kirov 1": "Киров 1",
      "S. Turdiyev": "С Турдиев",
      "Kulob": "Кулоб",
      "Aynidin Kurbonov": "Айнидин Курбонов",
      "Uzbekiston (Peshqadam)": "Узбекистон (Пешқадам)",
      "Navruz(Yakkatut)": "Наврӯз (Яккатут)",
      "Istiqlol (1 May)": "Истиқлол (1 май)",
      "Vakhsh (Vahdat)": "Вахш (Ваҳдат)",
      "Dusti (Javoni)": "Дӯстӣ (Ҷавонӣ)",
      "Mash'al (Senakos)": "Машъал (Сенакос)",
      "Tojikiston": "Тоҷикистон",
      "Tojikobod (Haqiqat)": "Тоҷикобод (Ҳақиқат)",
      "Vose TB Center": "Маркази бемории сили Восеъ",
      "District HC Vose": "МСН райони Восеъ",
      "Ohchar": "Охчар",
      "Bahoriston": "Баҳористон",
      "Kaduchi 1": "Кадучи 1",
      "Kaduchi 3": "Кадучи 3",
      "Sulhobod": "Сулхобод",
      "Fayzobod": "Файзобод",
      "Guliston": "Гулистон",
      "Kaftarhona": "Кафтархона",
      "Toskala": "Тоскала",
      "Shobika": "Шобика",
      "Zarkoron": "Заркорон",
      "Selbur": "Селбур",
      "Sarichashma": "Саричашма",
      "Hasan Kurbon": "Хасан Курбон",
      "Gulobod": "Гулобод",
      "Navbahor": "Навбахор",
      "Kurboshaid 1": "Курбошаид 1",
      "Gelot": "Гелот",
      "Darnaychi": "Дарнайчи",
      "Kurboshaid 2": "Курбошаид 2",
      "S.Sharif": "С.Шариф",
      "Gulrud": "Гулруд",
      "Pahtakor": "Пахтакор",
      "Istiqlol": "Истиқлол",
      "Voseobod": "Восеъобод",
      "Homid barot": "Хомид Барот",
      "Tugarak": "Тугарак",
      "Javoni": "Чавонй",
      "Navobod": "Навобод",
      "Chorbog": "Чорбог",
      "Zarkamar": "Заркамар",
      "Kaduchi 2": "Кадучи 2",
      "Pushyoni miyona": "Пушёни миёна",
      "Hulbek": "Хулбек",
      "Zafarobod": "Зафаробод",
      "Rudaki": "Рӯдакӣ",
      "Anoriston": "Анористон",
      "Kaynar": "Кайнар",
      "Dangara TB Center": "Маркази мубориза бар зидди бемории сил дар Данғара",
      "District HC Dangara": "МСН Данғара",
      "Tojmahal (Lohur)": "Тоҷмаҳал (Лоҳур)",
      "Hoja Shakiki Balhi (Sebiston)": "Хоҷа Шакики Балҳӣ (Себистон)",
      "District HC Shamol dara (Gumsu)": "МСН ноҳияи Шамол-дара (Гумсу)",
      "Bulyoni poyon": "Булёни поён",
      "Guliston": "Гулистон",
      "District HC Navobod": "МСН Навобод",
      "Gargara": "Гаргара",
      "Mehtar (Sargaron)": "Мехтар (Саргарон)",
      "Chorsada": "Чорсада",
      "Osmon dara (Hachaguzar) ": "Осмон дара (Хачагузар)",
      "Sangtuda": "Сангтуда",
      "Dangarai bolo": "Данғараи боло",
      "Hurramzamin (Jarteppa)": "Ҳуррамзамин (Ҷартеппа)",
      "Bobotuphona": "Боботухона",
      "Bulyoni Bolo": "Булёни Боло",
      "Fayzbahsh (Qushbuloq)": "Файзбахш (Қушбулоқ)",
      "Safobahsh (Oqsu)": "Сафобахш (Оқсу)",
      "Malikova": "Маликова",
      "Pushing": "тела додан",
      "Alijon": "Аличон",
      "Gichovak": "Гичовак",
      "J.Balkhi TB Center": "Маркази бемории сил ба номи Ҷ.Балхӣ",
      "District HC balkhi": "МСН Балхй",
      "Navobod": "Навобод",
      "Qizil-Tojikiston": "Қизил-Тоҷикистон",
      "Uzun": "Узун",
      "Sanoat": "Саноат",
      "K-Marks": "К-Маркс",
      "A.Dustov": "А.Дустов",
      "Lohuti": "Лоҳутӣ",
      "Leningrad": "Ленинград",
      "Toshrobod": "Тошробод",
      "Isankulov": "Исанкулов",
      "Guliston": "Гулистон",
      "Hosilot": "Хосилот",
      "Frunze": "Фрунзе",
      "Sino": "Сино",
      "Ittifoq": "Иттифок",
      "U.Namozov": "У.Намозов",
      "Kalenin": "Каленин",
      "Dusti TB Center": "Маркази бемории сил Дӯстӣ",
      "District HC Dusti": "МСН Дустй",
      "Nayson (Agronom)": "Нейсон (Агроном)",
      "Ergash Sultonov": "Эргаш Султонов",
      "Markaz (Engels)": "Марказ (Энгельс)",
      "Istiqlol (Lebap)": "Истиқлол (Либап)",
      "Dehqonobod": "Дехконобод",
      "Qubodiyon": "Қубодиён",
      "Achisel (Kuhdoman)": "Ачисел (Кӯҳдоман)",
      "Shahrinav": "Шаҳринав",
      "20 sol. Istiqloliyati Tojikiston (Garauti)": "20 сол. Истиқлолияти Тоҷикистон (Гараутӣ)",
      "Eshbek Sattorov": "Эшбек Сатторов",
      "Dusti": "Дустй",
      "Buston": "Бустон",
      "Gogol": "Гогол",
      "Komsomol": "комсомолй",
      "Qubodiyon TB Center": "Маркази бемории сил Қубодиён",
      "District HC Qubodiyon": "МСН Ноҳияи Қубодиён",
      "Alisher Navoi": "Алишер Навоий",
      "Pahtakor": "Пахтакор",
      "Arabhona": "Арабхона",
      "Ziraki": "Зираки",
      "Avesto": "Авесто",
      "Chorqurgan": "Чоркургон",
      "Vahdat (Qizil Ittifoq)": "Ваҳдат (Қизил Иттифоқ)",
      "Oq-Oltin": "Ок-Олтин",
      "Farogat": "Фарогат",
      "Tojikiston": "Тоҷикистон",
      "8-mart": "8-март",
      "Kamarob": "Камароб",
      "N.Husrav": "Н.Хусрав",
      "Qubodiyon": "Қубодиён",
      "Chimgilish": "Чимгилиш",
      "Uchqunobod": "Учкунобод",
      "Jayhun TB Center": "Маркази бемории сил Ҷайҳун",
      "District HC Jayhun": "ноҳияи Ҷайҳун",
      "District HC - 1 (Hasanov)": "МСН 1 (Хасанов)",
      "Lohuti-1": "Лоҳутӣ-1",
      "Vakhsh": "Вахш",
      "District HC № 2": "МСН № 2",
      "District HC № 8": "МСН № 8",
      "Sari pul": "Сари пул",
      "District HC № 3 (Rahmonov)": "МСН № 3 (Раҳмонов)",
      "Orzu": "Орзу",
      "Eshhonov (District HC - 4)": "Эшхонов (МСН 4)",
      "E.Mahmadov (District HC - 5)": "Э.МАХМАДОВ (МСН 5)",
      "Hamadoni TB Center": "Маркази мубориза бо сили Ҳамадонӣ",
      "District HC Qabulgoh": "МСН Кабулгох",
      "Gulobod": "Гулобод",
      "Dashtigulo": "Даштигуло",
      "Darai kalot (Fayzali Saidov)": "Дараи калот (Файзали Саидов)",
      "D. Halifaev": "Халифаев Д",
      "Dusti": "Дустй",
      "Davlatobod": "Давлатобод",
      "Mehnatobod": "Мехнатобод",
      "M. Rahimov": "Раҳимов М",
      "Margob": "Маргоб",
      "Oqmazor (Mehrvar)": "Оқмазор (Меҳрвар)",
      "Pushkin": "Пушкин",
      "Safedob": "Сафедоб",
      "Sarhadchi": "Сархадчй",
      "Sovetobod (Obshoron)": "Советобод (Обшорон)",
      "S. Turdiyev": "С Турдиев",
      "Tagnob": "Тагноб",
      "Hoja Mumin": "Хоҷа Мумин",
      "Muminobod TB Center": "Маркази мубориза бо сили Муъминобод",
      "District HC Muminobod": "МСН Муъминобод",
      "Shahri nav": "Шаҳри нав",
      "Gesh": "Геш",
      "Momandiyon": "Момандиён",
      "Kulchashma": "Кулчашма",
      "Sadbargoh": "Садбаргох",
      "Hanatarosh": "Ҳанатарош",
      "Sarmaydon": "Сармайдон",
      "Tutqavul": "Тутқавул",
      "Dehlolo": "Дехло",
      "Ohjar (Navbahor)": "Оҳҷар (Навбаҳор)",
      "Dusti (Sarsibuloq)": "Дӯстӣ (Сарсибулоқ)",
      "Boggai": "Боггай",
      "Chorbog (Chuqurqishloq)": "Чорбоғ (Чуқурқишлоқ)",
      "Langar": "Лангар",
      "Tuto": "Туто",
      "Momirak": "Момирак",
      "Bogi Habib": "Боги Хабиб",
      "(Sh.Shohin) Tu-tu": "(Ш.Шохин) Ту-ту",
      "Sangdara": "Сангдара",
      "Qipchoq (Chashmasor)": "Қипчоқ (Чашмасор)",
      "Shahrak": "Шаҳрак",
      "Dehibaland": "Дехибаланд",
      "N.Hisrav TB Center": "Маркази мубориза бо бемории сил ба номи Н.Ҳисрав",
      "District HC N.Hisrav": "МСН Н. Хисрав",
      "Kamsomol": "комсомолй",
      "Orzu-1": "Орзу-1",
      "Voroshilov (Beshkapa)": "Ворошилов (Бешкапа)",
      "Beshkent-2 (Tulaganov)": "Бешкент-2 (Тулаганов)",
      "Norak TB Center": "Маркази бемории сил Норак",
      "CHC Norak": "МСШ Норак",
      "Dukoni": "Дукони",
      "Tutqavul": "Тутқавул",
      "Langar": "Лангар",
      "Panj TB Center": "Маркази мубориза бо сили Панҷ",
      "District HC Panj": "МСН Панҷ",
      "Orjonikidze": "Орчоникидзеобод",
      "Komsomol": "комсомолй",
      "Safedorun": "Сафедорун",
      "Turdi Shayh": "Турди Шайх",
      "Madaniyat ": "Маданият",
      "Nuri Vahdat (Tugul)": "Нури Вахдат (Тугул)",
      "Kuldimon uch. Q-Yulduz": "Кулдимон уч. Q-Юлдуз",
      "Kirov (Bedak)": "Киров (Бедак)",
      "Somoni": "сомонӣ",
      "Namuna Peshqadam": "Намуна Пешқадам",
      "Pahtakor": "Пахтакор",
      "Dehbaland": "Дехбаланд",
      "Temurmalik TB Center": "Маркази бемории сил Темурмалик",
      "District HC Temurmalik": "МСН ноҳияи Темурмалик",
      "Kangurt": "Кангурт",
      "Safarboyon": "Сафарбоён",
      "Chavroq": "Чаврок",
      "Dusti Shuluptu": "Дӯстӣ Шулупту",
      "Boboyunus": "Бобоюнус",
      "Bahoriston (Jantoqli)": "Баҳористон (Ҷантоқли)",
      "Tanobchi": "Танобчй",
      "Qushqiya (L.Karmishev)": "Қушқия (Л.Кармишев)",
      "Vatan (S. Rahimov)": "Ватан (С. Раҳимов)",
      "Davad": "Давад",
      "Farhor TB Center": "Маркази бемории сил Фархор",
      "District HC Farhor": "МСН Фархор",
      "Vatan (Lenin)": "Ватан (Ленин)",
      "Kuhdoman (Mayda pata) ": "Куҳдоман (Майда пата)",
      "Sadoqat (Qizil mojir)": "Садоқат (Қизил моҷир)",
      "Kuhandiyori poyon (Orjonikidze)": "Куҳандиёри поён (Орчоникидзе)",
      "Lolazor": "Лолазор",
      "Haqiqat (Pravda)": "Ҳақиқат (Правда)",
      "Kuhandiyori Bolo (Saksanohur)": "Куҳандиёри боло (Саксонохур)",
      "Sebi Surh": "Себи Сурх",
      "Gayrat (Dehqonariq)": "Гайрат (Деҳқонариқ)",
      "25 – solagii Tojikiston": "25 — солагии Тоҷикистон",
      "Zafar (40-solagii Tojikiston)": "Зафар (40-солагии Тоҷикистон)",
      "Archa": "Арча",
      "Shorqul": "Шорқул",
      "Bobosafoli poyon": "Бобосафоли поён",
      "Alovudin": "Аловудин",
      "Hurramzamin (Tugul)": "Хуррамзамин (Тугул)",
      "Gulshan": "Гулшан",
      "Mojirobod": "Мочиробод",
      "Darqad": "Дарқад",
      "Mehrobod (Jayrali)": "Меҳробод (Ҷайраалӣ)",
      "Galaba": "Галаба",
      "20 sol. Istiqloliyat (Komsomol)": "20 сол. Истиқлолият (Комсомол)",
      "Navruz": "Наврӯз",
      "Hisor": "Хисор",
      "Qizil – su ": "қизил – су",
      "Surhob": "Сурхоб",
      "Hovaling Tb Center": "Маркази бемории сил",
      "District HCC Hovaling": "МСН Ховалинг",
      "Vose": "Восеъ",
      "Dorobi": "Дороби",
      "Chuqurak": "Чуқурак",
      "Darai Muhtor": "Дараи Мухтор",
      "Tokak": "Токак",
      "Lohuti": "Лоҳутӣ",
      "Sangrezgi": "Сангрезги",
      "Obidara": "Обидара",
      "Zarkuh": "Заркуҳ",
      "Halqayor": "Халқаёр",
      "Navroho (Kuldara)": "Наврохо (Кулдара)",
      "Chashmabedak": "Чашмабедак",
      "Sadbargo": "Садбарго",
      "Chombaht": "Чомбахт",
      "Sari-Osiyob ": "Сари-Осиёб",
      "Safedshahrak": "СафедШаҳрак",
      "Gulzor": "Гулзор",
      "Zelolak": "Зелолак",
      "Sangdara": "Сангдара",
      "Shugnov": "Шугнов",
      "Huroson TB Center": "Маркази бемории сил Ҳуросон",
      "District HC Huroson": "МСН ноҳияи Ҳисор Ҳуросон",
      "Jabbor Rasulov": "Чаббор Расулов",
      "Tokparvar": "Токпарвар",
      "Nizomi": "Низомй",
      "Mehnatobod-2": "Мехнатобод-2",
      "Jalolidini Rumi": "Ҷалолиддини Румӣ",
      "Alisher Navoi": "Алишер Навоий",
      "Tursun Uljaboev": "Турсун Улҷабоев",
      "Achchi": "Аччи",
      "Mirzorahimov (Uyali)": "Мирзорахимов (Уялй)",
      "Chorbog": "Чорбог",
      "Qizil-Qala": "Қизилқалъа",
      "Mehnatobod-1": "Мехнатобод-1",
      "Shahritus TB Center": "Маркази бемории сил Шаҳритус",
      "District HC Shahritus": "МСН Шаҳритус",
      "Ayvadj": "Айвадж",
      "Iskra": "Искра",
      "Pahtaobod": "Пахтаобод",
      "Mashinizatsiya (Ustokoron)": "Мошинизация (Устокорон)",
      "Sayod": "Сайёд",
      "Hushodi": "Ҳушодӣ",
      "Tojikobod": "Тоҷикобод",
      "Birlash": "Бирлаш",
      "Hokak": "Хокак",
      "Obshoron": "Обшорон",
      "Sh.Shohin TB Center": "Маркази мубориза бар зидди бемории сил ба номи Ш.Шоҳин",
      "District HC Sh.Shohin": "МСН ноҳияи Ш.Шоҳин",
      "Zulmobod": "Зулмобод",
      "Devdor": "Девдор",
      "Dogiston": "Догистон",
      "Shahribarbar": "Шаҳрибарбар",
      "Darai Ob": "Дараи Об",
      "Kaftar": "Кафтар",
      "Chagam": "Чагам",
      "Sarichashma": "Саричашма",
      "Yalabuli (Pistamazor)": "Ялабули (Пистамазор)",
      "Yol": "Ёл",
      "Porvor": "Порвор",
      "Hirmanjo": "Хирманчо",
      "Dashtijum": "Даштичум",
      "Langar": "Лангар",
      "Navo": "Наво",
      "Yovon TB Center": "Маркази бемории сил Ёвон",
      "District HC Yovon": "МСН Ёвон",
      "Chrmagzak": "Чрмагзак",
      "Dusti": "Дустй",
      "Shirinbuloq": "Ширинбулоқ",
      "Ozodi": "Озодӣ",
      "Charogchi": "Чарогчй",
      "Dahana": "Дахана",
      "Garav": "Гарав",
      "Gulsara Yusupova (Navkoram)": "Гулсара Юсупова (Навкорам)",
      "Dashtobod": "Даштобод",
      "Tagoyobod": "Тагойобод",
      "Qashqaraha": "Қашқараҳа",
      "Qirgochak (Anoriston)": "Қирғизистоночак (Анористон)",
      "Qaynama": "Қайнома",
      "Parchasoy": "Парчасой",
      "Rudaki": "Рӯдакӣ",
      "Navobodi - 4": "Навободӣ - 4",
      "Furqat": "Фурқат",
      "Hayoti-nav": "Хаёти-нав",
      "Hamza": "Хамза",
      "Sadi-Sherozi": "Саъди Шерозй",
      "Urta-qaynar": "Урта-кайнар",
      "Pahtakor (Eshma)": "Пахтакор (Эшма)",
      "Bosh-qaynar": "Бош-кайнар",
      "Bahor": "Бахор",
      "Shurcha": "Шурча",
      "Gulafshon": "Гулафшон",
      "Qulobod": "Кулобод",
      "Buston-2": "Бустон-2",
      "Guliston Kunchi+buston-1": "Гулистон Кунчи+бустон-1"
    }
  },
  "ru": {
    "translation": {
      "Upload": "Загрузить",
      "Dashboard": "Панель приборов",
      "Prevent TB - Tajikistan": "Prevent TB Таджикистан",
      "home": "Главная",
      "Line List": "Список",
      "Alerts": "Оповещения",
      "Smart Setup": "Setup Smart",
      "Users": "Пользователи",
      "Index Upload": "Загрузка индекса",
      "QR Code": "QR код",
      "QR Code Generation": "Генерировать QR-кода",
      "Logout": "Выход",
      "Reset ": "Сброс настроек",
      "Index registered": "Индексов зарегистрировано",
      "Key population Registered": "Ключевые группы населения (зарегистрированные)",
      "Contact registered": "Контактных зарегистрировано",
      "Contact screened": "Проскринированные контакты",
      "Referred to Investigation - TB": "Направлено на исследование - ТБ",
      "Referred to Investigation - LTBI": "Направлено на исследование - ЛТБИ",
      "TB Negative": "ТБ отрицательный",
      "TB Postive": "ТБ положительный",
      "LTBI Negative": "ЛТБИ отрицательный",
      "LTBI Positive": "ЛТИ положительный",
      "Total registered - Index and Contact": "Всего зарегистрированных - индексов и контактых",
      "TB and LTBI cases": "Случаи ТБ и ЛТБИ",
      "TB testing - Positive": "Тестирование на ТБ - положительное",
      "LTBI testing - Positive": "Тест на ЛТБИ - положительный",
      "Gender": "Пол",
      "Reset Map": "Сбросить карту",
      "Gender (male)": "Гендер (мужской)",
      "Gender (female)": "Гендер (женский)",
      "Gender (TG)": "Гендер (TG)",
      "Hotspot Details": "Сведения о точке доступа",
      "Select Filter": "Выберите фильтр",
      "Organisation Units": "Подразделения",
      "Tajikistan": "Таджикистан",
      "Period": "Периуд",
      "Period Type": "Тип периода",
      "Select Period Type": "Тип периода",
      "Yearly": "Ежегодно",
      "Apply": "Применить",
      "Powered By": null,
      "null": null,
      "All": "Все",
      "Index": "Индекс",
      "Contact": "Контакт",
      "Key Population": "Ключевое население",
      "Search": "Поиск",
      "Cases": "Случаи",
      "Page": "Страница",
      "Go to page": "Перейти к странице",
      "Show": "Показать",
      "Export Data": "Экспорт данных",
      "UIC": "UIC",
      " Name": "Имя",
      "Name": "Имя",
      "District": "Район",
      "Mobile Number": "Номер телефона",
      "Age (in years)": "ВОЗРАСТ",
      "Observation Type": "Тип наблюдения",
      "Presently on anti-TB medication?": "В настоящее время на ТБ препаратах",
      "ALERTS": "ОПОВОЩЕНИЯ",
      "Threshold Value": "Пороговое значение",
      "Days": "Дни",
      "No Data": "Нет данных",
      "Enter Number of QR Codes to be Generated": "Введите количество QR-кодов для генерации",
      "Generate": "Генерировать",
      "Leaflet": "Листовка",
      "N/A": "Н/Д",
      "of": "из",
      "Registered By": "ЗАРЕГИСТРИРОВАНО КЕМ",
      "Select Role": "Выберите роль",
      "Select User": "Выберите пользователя",
      "Select Organisation Unit": "Выберите организационное подразделение",
      "Select Municipality": "Выберите регион",
      "Select CHC": "Выберите район",
      "Select Block": "Выберите учреждение",
      "Enter Number of QR Codes to be Generated": "Введите количество QR-кодов, которые будут сгенерированы",
      "Generate QR Code": "Сгенерировать QR-код",
      "Age": "ВОЗРАСТ",
      "Are you sure you want to logout?": "Вы действительно хотите выйти?",
      "& Above": "& Выше",
      "Yes": "Да",
      "No": "Нет",
      "Date Range": "Диапазон дат",
      "Monthly": "Ежемесячно",
      "Quarterly": "Поквартально",
      "Yearly": "Ежегодно",
      "No Alerts": "Нет оповещений",
      "records": "records",
      "Details": "Детали",
      "Treatment Initiation": "Начало лечения",
      "Select": "выбрать",
      "All Rights Reserved" : "Все права защищены",
      "Quarter 1(Jan-Mar)" : "1 квартал (январь-март)",
      "Quarter 2(Apr-Jun)" : "2 квартал (апрель-июнь)",
      "Quarter 3(Jul-Sep)" : "3 квартал (июль-сентябрь)",
      "Quarter 4(Oct-Dec)" : "4 квартал (октябрь-декабрь)",
      // ORG LABEL.............................................................................................
      "Tajikistan" : "Таджикистан",
      "РРП": "РРП",
      "Сугд": "Сугд",
      "Хатлон": "Хатлон",
      "GBAO": "ГБАО",
      "Dushanbe": "Душанбе",
      "Rudaki": "Рудаки",
      "Vahdat": "Вахдат",
      "Varzob": "Варзоб",
      "Hisor": "Хисор",
      "Lahsh": "Лахш",
      "Nurobod": "Нуробод",
      "Rasht": "Рашт",
      "Rogun": "Рогун",
      "Sangvor": "Сангвор",
      "Tojikobod": "Точикобод",
      "Tursunzoda": "Турсунзода",
      "Fayzobod": "Файзобод",
      "Shahrinav": "Шахринав",
      "Khujand": "Худжанд",
      "Guliston": "Гулистон",
      "Istiqlol": "Истиклол",
      "Buston": "Бустон",
      "Ayni": "Айни",
      "Asht": "Ашт",
      "B.Gafurov": "Б.Гафуров",
      "Devashtich": "Деваштич",
      "Kuhistoni Mastchoh": "Кухистони Мастчох",
      "J.Rasulov": "Ч.Расулов",
      "Zafarobod": "Зафаробод",
      "Istaravshan": "Истаравшан",
      "Isfara": "Исфара",
      "Konibodom": "Конибодом",
      "Mastchoh": "Мастчох",
      "Panjakent": "Панчакент",
      "Spitamen": "Спитамен",
      "Shahriston": "Шахристон",
      "Bokhtar": "Бохтар",
      "Kulob": "Кулоб",
      "Levakant": "Левакант",
      "A.Jomi": "А.Чоми",
      "Baljuvon": "Балчувон",
      "Kushoniyon": "Кушониён",
      "Vahsh": "Вахш",
      "Vose": "Восеъ",
      "Dangara": "Дангара",
      "J.Balkhi": "Ч.Балхи",
      "Dusti": "Дусти",
      "Qubodiyon": "Кабодиён",
      "Jayhun": "Чайхун",
      "Hamadoni": "Хамадони",
      "Muminobod": "Муминобод",
      "N.Hisrav": "Н.Хисрав",
      "Norak": "Норак",
      "Panj": "Панч",
      "Temurmalik": "Темурмалик",
      "Farhor": "Фархор",
      "Hovaling": "Ховалинг",
      "Huroson": "Хуросон",
      "Shahritus": "Шахритус",
      "Sh.Shohin": "Ш.Шохин",
      "Yovon": "Ёвон",
      "Khorug": "Хоруг",
      "Vanj": "Ванч",
      "Darvoz": "Дарвоз",
      "Ishkoshim": "Ишкошим",
      "Murgob": "Мургоб",
      "Roshqala": "Рошткала",
      "Rushon": "Рушон",
      "Shugnon": "Шугнон",
      "PHC №2": "Поликлиника №2",
      "PHC №3": "Поликлиника №3",
      "PHC №4": "Поликлиника №4",
      "PHC №5": "Поликлиника №5",
      "PHC №6": "Поликлиника №6",
      "PHC №7": "Поликлиника №7",
      "PHC №8": "Поликлиника №8",
      "PHC №9": "Поликлиника №9",
      "PHC №10": "Поликлиника №10",
      "PHC №11": "Поликлиника №11",
      "PHC №12": "Поликлиника №12",
      "PHC №1": "Поликлиника №1",
      "PHC №14": "Поликлиника №14",
      "PHC №15": "Поликлиника №15",
      "Zaynabobod": "Зайнабобод",
      "Russia": "Россия",
      "Rohati": "Рохати ",
      "Qiblai": "Киблаи",
      "Guliston ": "Гулистон ",
      "Sultonobod": "Султонобод",
      "Somoniyon": "пгт Сомониен",
      "Esanboy": "Эсанбой",
      "Chorgulteppa": "Чоргултеппа",
      "Lohur": "Лохур",
      "Ishkobod": "Ишкобод",
      "Chimteppa": "Чимтеппа",
      "Sarikishti": "Сарикишти",
      "Navobod": "Навобод",
      "Chorteppa": "Чортеппа",
      "Choryakkaron": "Чоряккорон",
      "DOTS 2": "ДОТС 2",
      "DOTS 3": "ДОТС 3",
      "RHC Romit": "СЦЗ Ромит ",
      "Yavroz": "Явроз",
      "Hushon": "Хушон",
      "Sayod": "Сайёд",
      "Vistan": "Вистан",
      "Tvishi poyon": "Твиши-поен",
      "Sorvo": "Сорво",
      "Loshharf": "Лошхарф",
      "Varva": "Варва",
      "Yafrak": "Яфрак",
      "RHC Tangay": "СЦЗ Тангай",
      "RHC Lichak": "СЦЗ Личак (15 км)",
      "Shorazm": "Шоразм",
      "Chuyangaron": "Чуянгарон",
      "Hordara": "Хордара ",
      "RHC Amonshayhi": "СЦЗ Амоншайхи",
      "Shahdrez": "Шахдрез",
      "RHC Chorbog": "СЦЗ Чорбог",
      "Yums ": "Ю",
      "RHC Bakaron": "СЦЗ Бакарон",
      "Shabgardi": "Шабгарди ",
      "RHC Simiganj": "СЦЗ Симиганҷ",
      "RHC Firishti": "СЦЗ Фиришти",
      "Arbobi": "Арбоби",
      "Panjikon": "Панчикон",
      "Odily": "Одилй",
      "Sarchinor": "Сарчинор",
      "RHC navruz": "СЦЗ Навруз",
      "RHC Kipchok": "СЦЗ Кипчок",
      "Nozirobod": "Нозиробод",
      "RHC Hojikatagan": "СЦЗ Хочикатаган",
      "Guliston ": "Гулистон",
      "Zafarobod": "Зафаробод",
      "Machiton": "Мачитон",
      "Gulbog": "Гулбог",
      "RHC Kamongaron": "СЦЗ Камонгарон",
      "RHC Bahor": "СЦЗ Бахор",
      "Pistamazor": "Пистамазор",
      "RHC Guliston": "СЦЗ Гулистон",
      "Dahana": "Дахана",
      "Hirgatarosh": "Хиргатарош",
      "Dehqonobod": "Дехконобод",
      "RHC Tilloi safed": "СЦЗ Тиллои сафед",
      "Jarteppa": "Чартеппа",
      "Kuhdoman": "Кухдоман",
      "RHC Buston": "СЦЗ Бустон",
      "Kishovarz": "Кишоварз",
      "Hakikat": "Хакикат",
      "Jangalobod": "Чангалобод",
      "Adolat": "Адолат",
      "RHC Mehrbahsh": "СЦЗ Мехрбахш",
      "Abdurasuli": "Абдурасули",
      "Madaniyat-1": "Маданият-1",
      "Navbahor": "Навбахор",
      "Istiqloliyat": "Истиклолият",
      "Surhchashma": "Сурхчашма",
      "Madaniyat-2": "Маданият-2",
      "RHC Ganjbor": "СЦЗ Ганчбор",
      "Sitorai surh": "Ситораи сурх",
      "Charboshi": "Чарбоши",
      "RHC Dusti": "СЦЗ Дусти",
      "Muminobod": "Муминобод",
      "RHC Qarsang": "СЦЗ Карсанг",
      "Buzbit": "Бузбит",
      "RHC Navobod": "СЦЗ Навобод",
      "Mehnatobod": "Мехнатобод",
      "RHC Boston": "СЦЗ Бостон",
      "Arbobdara": "Арбобдара",
      "Naydara": "Найдара",
      "Sangpar": "Сангпар",
      "Sugdiyon": "Сугдиен",
      "Gurghurda": "Гургхурда",
      "Holmurodi": "Холмуроди",
      "RHC Bahoriston": "СЦЗ Бахористон",
      "Zardolu": "Зардолу",
      "Qalai mali": "Калъаи малик",
      "Yalanchinor": "Яланчинор",
      "Chepisoleh": "Чеписолех",
      "Gulakandoz": "Ғулакандоз",
      "Galchari": "Ғалчаги",
      "Geshi": "Ғеши",
      "RHC B.Burunov": "СЦЗ Б.Бурунов",
      "Fayzbahsh": "Файзбахш",
      "Mehrobod": "Мехробод",
      "RHC Girdob": "СЦЗ Гирдоб",
      "Chirtak": "Чиртак",
      "RHC Shifo": "СЦЗ Шифо",
      "Javonon": "Чавонон",
      "Shirinchashma": "Ширинчашма",
      "Zarteppa": "Зартеппа",
      "RHC Solehon": "СЦЗ Солехон",
      "Sarchashma": "Саричашма",
      "Zulfi": "Зулфи",
      "Sufiyon": "Суфиён",
      "RHC Gulrez": "СЦЗ Гулрез",
      "Andigon": "Андигон",
      "Ganjina": "Ганчина",
      "RHC Chillamazor": "СЦЗ Чилламазор",
      "Sharifobod": "Шарифобод",
      "Zargar": "Заргар",
      "Mehrgon": "Мехргон",
      "RHC Kofarnihon": "СЦЗ Кофарнихон",
      "Chinor": "Чинор",
      "Dashtibedi kalon": "Даштибеди калон",
      "Dashtibedi hurd": "Даштибеди хурд",
      "Elovar": "Эловар",
      "Obidara": "Обидара",
      "Chaman": "Чаман",
      "Bahoriston": "Бахористон",
      "Hisor TB Center": "ТБ Центр г.Гисар ",
      "Almosi": "Алмоси",
      "Bobosurhon": "Бобосурхон",
      "Vatan": "Ватан",
      "Guli surh": "Гули сурх",
      "Gulhani": "Гулхани",
      "Gayratobod": "Гайратобод",
      "Guriyot": "Гуриёт",
      "Dehqonobod": "Дехконобод",
      "Durbat": "Дурбат",
      "Duchinora": "Дучинора",
      "Iskich": "Искич",
      "Kavshduzon": "Кавшдузон",
      "Dahbed": "Дахбед",
      "Mehrobod": "Мехробод",
      "Niyogon": "Ниёгон",
      "Mehrgon": "Мехргон",
      "Lolagi": "Лолаги",
      "Morteppa": "Мортеппа",
      "Navobod": "Навобод",
      "Nilu": "Нилу",
      "Nochi-bolo": "Ночи-боло",
      "Oybosh": "Ойбош",
      "Sumbula": "Сумбула",
      "Sangchashma": "Сангчашма",
      "Tuda": "Туда",
      "Uzbekiston": "Узбекистон",
      "Hayotinav": "Хаётинав",
      "Honakoi Kuhi": "Хонакои Кухи",
      "Hiloli Ahmar": "Хилоли Ахмар",
      "Hisor": "Хисор",
      "Sugdiyon": "Сугдиён",
      "Javoni": "Чавони",
      "Halkarud": "Халкаруд",
      "Sharora": "Шарора",
      "Nurafshon": "Нурафшон",
      "Tursunzoda TB Center": "ТБ Центр г.Турсунзода",
      "Durbent": "Дурбент",
      "Dusti": "Дусти",
      "Kommunizm": "Коммунизм",
      "Quzi-bacha": "Кузи-бача",
      "Leninizm": "Ленинизм",
      "Moskva": "Москва",
      "Pahtashirkat": "Пахташиркат",
      "Pahtakor": "Пахтакор",
      "Pravda": "Правда",
      "Sarkor": "Саркор",
      "Toychi": "Тойчи",
      "Husnobod": "Хуснобод",
      "Chkalov": "Чкалов",
      "Pahtaobod": "Пахтаобод",
      "Yangiturmush": "Янгитурмуш",
      "Efiranos": "Эфиранос",
      "Devak": "Девак",
      "Beshteppa": "Бештеппа",
      "Chinor": "Чинор",
      "Qaratog": "Каратог",
      "Qizil-nishon": "Кизил-нишон",
      "Kalinin": "Калинин",
      "Frunze": "Фрунзе",
      "Oqtosh": "Октош",
      "Batosh": "Батош",
      "Guliston ": "Гулистон",
      "Oqtelpak": "Октелпак",
      "Istiqlol": "Истиклол",
      "Shahrinav TB Center": "ТБ Центр Шахринав",
      "Navobod": "Навобод",
      "Qadi juybor": "Кади чуйбор",
      "Shurob": "Шуроб",
      "Istiqlol": "Истиклол",
      "Pahtakor": "Пахтакор",
      "Bahoriston": "Бахористон",
      "Chust": "Чуст",
      "Uzun": "Узун",
      "Dehobod": "Дехобод",
      "Eloki": "Элоки",
      "Sangala": "Сангала",
      "Tojikistan": "Точикистон",
      "Bogiston": "Богистон",
      "Dolon": "Долон",
      "Ajam": "Ачам",
      "Akram Hasan": "Акрам Хасан",
      "Muloshodi": "Мулошоди",
      "M.Tursunzoda": "М.Турсунзода",
      "Khujand TB Center": "ТБ Центр Худжанд",
      "CHC №1 Khujand": "ГЦЗ №1 г. Хучанд",
      "CHC №2 Khujand": "ГЦЗ №2 г. Хучанд",
      "CHC №3 Khujand": "ГЦЗ №3 г. Хучанд",
      "CHC №4 Khujand": "ГЦЗ №4 г. Хучанд",
      "CHC №5 Khujand": "ГЦЗ №5 г. Хучанд",
      "Guliston TB Center": "ТБ Центр Гулистон",
      "CHC Qayroqum": "ГЦЗ Кайроккум",
      "Adrasmon": "Адрасмон",
      "Zarnisor": "Зарнисор",
      "Konsoy": "Консой",
      "Sirdaryo": "Сирдарё",
      "Choruqdarron": "Чорукдаррон",
      "Navgarzan": "Навгарзан",
      "Istiqlol TB Center": "Истиклол",
      "CHC Istiqlol": "ГЦЗ Истиклол",
      "Buston TB Center": "ТБ Центр Бустон",
      "CHC Buston": "ГЦЗ Бустон",
      "Ayni TB Center": "ТБ Центр Айни",
      "District HC Ayni": "РЦЗ Айни",
      "Aslonobod": "Аслонобод",
      "Veshab": "Вешаб",
      "Veshkand": "Вешканд",
      "Darg": "Дарг",
      "Dardar": "Дардар",
      "Kum": "Кум",
      "Zerabod": "Зерабод",
      "Zoosun": "Зоосун",
      "Madm": "Мадм",
      "Pohut": "Похут",
      "Rarz": "Рарз",
      "Revad": "Ревад",
      "Urmetan": "Урметан",
      "Shavadki bolo": "Шавадки боло",
      "Shamtuch": "Шамтуч",
      "District HC №1 Zarafshon": "РЦЗ №1 Зарафшон",
      "Tagi Chinor": "ДЗ Таги Чинор",
      "Gaberut": "ДЗ Габерут",
      "Mahshevad": "Махшевад",
      "Dijik": "Дижик",
      "Asht TB Center": "ТБ Центр Ашт",
      "District HC Shaydon": "РЦЗ Шайдон",
      "Bobokir": "Бобокир",
      "Makarenko": "Макаренко",
      "Dusti": "Дусти",
      "Asht": "Ашт",
      "Oriyon": "Ориён",
      "Qamishqurgan": "Камишкурган",
      "Djigda": "Джигда",
      "Iftihor": "Ифтихор",
      "Marhamat": "Мархамат",
      "Appon": "Аппон",
      "Oshoba": "Ошоба",
      "Sudja": "Суджа",
      "Saro": "Саро",
      "Bobodarhon": "Бободархон",
      "Pushta": "Пушта",
      "Pongoz": "Понгоз",
      "Punuk": "Пунук",
      "Gulshan": "Гульшан",
      "B.Gafurov TB Center": "ТБ Центр Б.Гафуров",
      "District HC B.Gafurov": "РЦЗ Б.Гафуров",
      "Qistakoz": "Кистакоз",
      "Histavers": "Хистеварз",
      "Zarzamin": "ДЗ Д Зарзамин",
      "Tojikistan": "Точикистон",
      "A.Sattorov": "А.Сатторов",
      "Kintirik": "Кинтирик",
      "Yava": "Ява",
      "Toshloq": "Тошлок",
      "Sirdaryo": "Сирдарья",
      "H.Usmon": "Х.Усмон",
      "Odil": "Одил",
      "Undji": "Унджи",
      "Dashtak": "Даштак",
      "Isfisor": "Исфисор",
      "Hodjent": "Ходжент",
      "Dashti Amin": "Дашти Амин",
      "Ismoil": "Исмоил",
      "Baht": "Бахт",
      "Qizil Yulduz": "Кизил Юлдуз",
      "Ovuchi kalacha": "Овучи Калача",
      "Kulangir": "Кулангир",
      "Utkansoy": "Уткансой",
      "Oktepa": "Октепа",
      "Gaziyan": "Газиян",
      "Chorsu": "Чорсу",
      "Kotma": "Котма",
      "Vodnik": "Водник",
      "Bogparvar": "Богпарвар",
      "Devashtich TB Center": "ТБ Центр Деваштич",
      "District HC Devashtich": "РЦЗ Деваштич",
      "District HC №1 Kalininobod": "РЦЗ №1 Калининобод",
      "Lolazor": "СЦЗ № 1 Лолазор",
      "Hushtoiri Muhlon": "СЦЗ № 2 Хуштоири мухлон",
      "Zarnisor": "СЦЗ № 3 Зарнисор",
      "Muchun": "СЦЗ № 4 Мучун",
      "Nurobod": "СЦЗ № 5 Нуробод",
      "Istiqlol": "СЦЗ № 6 Истиклол",
      "hazorchashma": "СЦЗ № 7 Хазорчашма",
      "Surhob": "СЦЗ № 8 Сурхоб",
      "Basmanda": "СЦЗ № 9 Басманда",
      "Ovchi": "СЦЗ № 10 Овчи",
      "Dahkat": "СЦЗ № 11 Дахкат",
      "Hishekat": "СЦЗ № 12 Хишекат",
      "Rosrovut": "СЦЗ № 13 Росровут",
      "Metk": "СЦЗ № 14 Метк",
      "Dalyani Bolo": "СЦЗ № 15 Дальяни боло",
      "Dalyani poyon": "СЦЗ № 16 Дальяни поён",
      "Kuhistoni Mastchoh TB Center": "ТБ Центр Кухистони Мастчох",
      "District HC Kuhistoni Mastchoh": "РЦЗ Кухистони Мастчох",
      "Madrushkat": "Мадрушкат",
      "Pastigav": "Пастигав",
      "Revomutk": "Ревомутк",
      "Rog": "Рог",
      "Esiz": "Эсиз",
      "Regional TB Center Dehmoy": "ОЦБТ Дехмой",
      "District HC J.Rasulov": "РЦЗ Ч.Расулов",
      "4-um Mahlla": "4-й Махалла",
      "Guliston": "Гулистон",
      "Yangiqishloq": "Янгикишлок",
      "Yangiobod": "Янгиобод",
      "Qurgoncha": "Кургонча",
      "Gulhona": "Гулхона",
      "Gulyakindoz": "Гулякандоз",
      "Dehmoy": "Дигмай",
      "Zarafshon": "Зарафшон",
      "Parij Kommuna": "Париж Коммуна",
      "Tojikobod": "Тожикобод",
      "Uzbekqishloq": "Узбеккишлок",
      "Yangiqadam": "Янгикадам",
      "Zafarobod TB Center": "ТБ Центр Зафаробод",
      "CHC Zafarobod": "ГЦЗ Зафаробод",
      "Baht": "Бахт",
      "Guliston": "Гулистон",
      "Hayoti Nav": "Хаёти Нав",
      "Hamid Aliyev": "Хамид Алиев",
      "Login": "Логин",
      "Mehnatobod": "Мехнатобод",
      "Jomi": "Джоми",
      "Zarafshon (Komsomol)": "Зарвшон ( Комсомол)",
      "Istaravshan TB Center": "ТБ Центр Истаравшан",
      "HC №1": "ЦЗ №1",
      "HC №2": "ЦЗ №2",
      "Bobotago": "Боботащо",
      "Bogkalon": "Бощкалон",
      "Varsi": "Варсиы",
      "Vogat": "Вогат",
      "Qalai baland": "Калъаи баланд",
      "Qalachai kalon": "Калъачаи калон",
      "Kurushkada": "Курушкада",
      "lakat": "Лакат",
      "Mahallai Yasi": "Маьаллаи Яси",
      "Nijoni": "Нижони",
      "Nofaroj": "Нофарож",
      "Obodi": "Ободи",
      "Rugund": "Ругунд",
      "Orif": "С-фи Ориф",
      "Toshbek": "Тошбек",
      "Chavkandak": "Чавкандак",
      "Chorqurgon": "Чаркургон",
      "Chorbosh": "Чорбощ",
      "Yakkabosh": "Яккабощ",
      "Isfara TB Center": "ТБ Центр Исфара",
      "CHC Isfara": "ГЦЗ Исфара",
      "Navgilem": "Навгилем",
      "Oftobru": "Офтобру",
      "Kulkent": "Кулькент",
      "Chilgizi": "Чилгази",
      "Lakkon": "Лаккон",
      "Neftobod": "Нефтобод",
      "Zarkuh": "Заркух",
      "Nurafshon": "Нурафшон",
      "Matpari": "Матпари",
      "Chorqishloq": "Чоркишлок",
      "Surh": "Сурх",
      "Chorkuh": "Чоркух",
      "Voruh": "Ворух",
      "Honaobod": "Хонаобод",
      "Saridasht": "Саридашт",
      "Tidon": "Тидон",
      "Shurob": "Шуроб",
      "Hojai Alo": "Хочаи Аьло",
      "Konibodom TB Center": "ТБ Центр Конибодом",
      "CHC Konibodom": "ГЦЗ Конибодом",
      "Niyozbek": "Ниезбек",
      "Mahram": "Махрам",
      "Hamroboev": "Хамробоев",
      "Hamirjuy": "Хамирчуй",
      "Ortiqov": "Ортиков",
      "Dilovaron (Shaitkaroyan)": "Диловарон (Шаиткароян)",
      "Shurqurgon": "Шуркургон",
      "Zarbed": "Зарбед",
      "Kuruk": "Курук",
      "Puloton": "Пулотон",
      "Ravot": "Равот",
      "Patar": "Патар",
      "Galaba": "Галаба",
      "Dusti (Assor)": "Дусти (Ассор)",
      "Jahonzeb (Qaraqchiqum)": "Жахонзеб (Карачкикум)",
      "Lohuti": "Лохути",
      "Mastchoh TB Center": "ТБ Центр Мастчох",
      "District HC Mastchoh": "РЗЦ Мастчох ",
      "J.Mastchoh": "Дж.Мастчох",
      "Azizobod (M.Komsomoli)": "Азизобод (М.Комсомоли)",
      "J.Obburdon ": "Дж.Оббурдон ",
      "Fayz Sulton": "Файз Султон",
      "J.Paldorak ": "Дж.Палдорак ",
      "J.Avzikent (Navbahor)": "Дж.Авзикент (Навбахор)",
      "J.Kuruksoy Obshoron": "Дж.Куруксой Обшорон",
      "Panjakent TB Center": "ТБ Центр Панчакент",
      "CHC Panjakent": "ГЦЗ Панчакент",
      "Hurmi": "Хурми",
      "Ozodagon": "Озодагон",
      "Shingak": "ДЗ Шингак",
      "Voru": "Вору",
      "Ruknobod": "Рукнобод",
      "Porven": "Порвен",
      "Maykatta": "Майкатта",
      "Amondara": "Амондара",
      "Ravot": "Равот",
      "Navruzteppa": "Наврузтеппа",
      "Shurcha": "Шурча",
      "Sangi kabud": "Санги кабуд",
      "Farob": "Фароб",
      "Sarazm": "Саразм",
      "CHC Sarazm": "ГЦЗ Саразм",
      "Shurnova": "Шурнова ",
      "Childara": "Чиларча",
      "Chimqala": "Чимкалъа",
      "Mazor": "Мазор",
      "Gusar": "Гусар",
      "Navobod": "Навобод",
      "Dashto Qozi": "Дашти Кози",
      "Mindona": "Миндона",
      "Yori": "Ёри",
      "Kuloli": "Кулоли",
      "Artuch": "Артуч",
      "Panjrud": "Панджруд",
      "Negnot": "Негнот",
      "Margedar": "Маргедар",
      "Dasht": "Дашт",
      "Qumsoy": "Кумсой",
      "Suchina": "Сучина",
      "Filmandar": "Филмандар",
      "Kosatarosh": "Косатарош",
      "Sogdiana": "Согдиана",
      "Chorbog": "Чорбог",
      "Mogiyon": "Могиён",
      "Sor": "Сор",
      "Gezan": "Гезан",
      "Shing": "Шинг",
      "Toshmunor": "Тошмунор",
      "Spitamen TB Center": "ТБ Центр Спитамен",
      "District HC №1 Spitamen": "РЦЗ №1 Спитамен",
      "District HC №2 Spitamen": "РЦЗ №2 Спитамен",
      "hurramzamin": "Хуррамзамин",
      "Oktepa": "Октепа",
      "Havatag": "Хаватаг",
      "Yangtobod": "Янгтобод",
      "Qushtegirmon": "Куштегирмон",
      "Saidkurgon": "Саидкурғон",
      "Togoyak": "Тоғояк",
      "Langar": "Лангар",
      "Shahriston TB Center": "ТБ Центр Шахристон",
      "District HC Shahriston": "РЦЗ Шахристон",
      "Obodi": "Ободи",
      "Sebzor": "Себзор",
      "Bokhtar TB Center": "ТБ Центр Бохтар",
      "CHC Bokhtar": "ГЦЗ Бохтар",
      "Child HC Bokhtar": "Детский ЦЗ Бохтар",
      "Sarchashma (Nihi)": "Саричашма( Нихи )",
      "Gayrat": "Гайрат",
      "Hayoti Nav": "Хаёти Нав",
      "Zarbdor": "Зарбдор ",
      "Kulob TB Center": "ТБ Центр Кулоб",
      "Regional HC Kulob": "МСН Кулоб",
      "District HC Kulob": "РЦЗ Кулоб",
      "Honobod": "Хонобод",
      "Dahana": "Дахана",
      "Saryozii bolo": "Сарёзии боло",
      "Ziraki": "Зираки",
      "Aftobluk": "Афтоблук",
      "Hakimobod": "Ҳакимобод",
      "Lagmon": "Лағмон",
      "Chorbog": "Чорбоғ",
      "Khatlon": "Хатлон",
      "Panjosiyob": "Панҷосиёб",
      "CHC №1 Kulyab": "ГЦЗ №1 г. Куляб",
      "CHC №2 Kulyab": "ГЦЗ №2 г. Куляб",
      "Child HC Kulyab": "Детский ЦЗ Куляб",
      "Levakant Tb Center": "ТБ Центр Левакант",
      "CHC Sarband": "ГЦЗ Сарбанд",
      "Bohturobod": "Боҳтуробод",
      "Guliston": "Гулистон",
      "Okgaza №1": "Окгаза №1",
      "Kuli Sufiyon": "Кули суфиён",
      "A.Jomi TB Center": "ТБ Центр А. Ҷомӣ",
      "District HC A.Jomi": "РЦЗ А. Джоми",
      "Bahor": "Баҳор",
      "Dusti (Yakkatut)": "Дустӣ (Яккатут)",
      "Tojikiston": "Тоҷикистон",
      "Lenin (Qadridin Giyosov)": "Ленин (Кадридин Гиёсов)",
      "Kalenin (Gulobod)": "Каленин (Гулобод)",
      "Galaba": "Ғалаба",
      "Mehnat": "Меҳнат",
      "Baljuvon TB Center": "ТБ Центр Балчувон",
      "District HC Baljuvon": "РЦЗ Балчувон",
      "RHC Oqbuloq": "СЦЗ Оқбулоқ",
      "RHC Sari hosor (Shahidon)": "СЦЗ Сари хосор (Шахидон)",
      "Hoirob": "Хироб",
      "Sari mazor": "Сари мазор",
      "Chorbog": "Чорбоғ",
      "Sulmolidasht": "Солмолидашт",
      "Navbahor (Satalmush)": "Навбаҳор (Саталмуш)",
      "Zarnisor (Dektur)": "Зарнисор (Дектур)",
      "Dashti Maydon": "Дашти майдон",
      "Guldara": "Гулдара",
      "Shingidara": "Шингидара",
      "Kushoniyon TB Center": "ТБ Центр Кушониён",
      "District HCC Kushoniyon": "РЦЗ Кушониён",
      "Voroshilov": "Ворошилов",
      "Zargar": "Заргар",
      "Komsomol": "Комсомол",
      "Pahtakor": "Пахтакор",
      "F.Saidov 3": "Ф.Саидов 3",
      "1-department": "1-отделение",
      "4-department": "4-отделение",
      "Navobod": "Навобод",
      "Urtabuz": "Уртабуз ",
      "Sarvati Istiqlol": "Сарвати Истиклол",
      "Lenin": "Ленин",
      "Sverdlov": "Свердлов",
      "Navkor": "Навкор",
      "Marksizm": "Марксизм",
      "Chorsu": "Чорсу ",
      "Istiqlol": "Истиқлол ",
      "S. Ayni": "С. Айнӣ",
      "Navbahor": "Навбаҳор",
      "Buston-Qal'a": "Бустон-Қалъа",
      "SMP-540": "СМП-540",
      "Sabzavot": "Сабзавот",
      "Rohi Lenin": "Роҳи Ленин",
      "Mehnatobod": "Меҳнатобод",
      "Vakhsh TB Center": "ТБ Центр Вахш",
      "District HCC Вахш": "РЦЗ Вахш",
      "Rudaki": "Рудаки",
      "Kirov 1": "Киров 1",
      "S. Turdiyev": "С.Турдиев",
      "Kulob": "Кулоб",
      "Aynidin Kurbonov": "Айнидин Курбонов",
      "Uzbekiston (Peshqadam)": "Узбекистон (Пешкадам)",
      "Navruz(Yakkatut)": "Навруз (Яккатут)",
      "Istiqlol (1 May)": "Истиқлол (1-МАЙ)",
      "Vakhsh (Vahdat)": "Вахш (Ваҳдат)",
      "Dusti (Javoni)": "Дусти (Ҷавони)",
      "Mash'al (Senakos)": "Машъал (Сенакос)",
      "Tojikiston": "Тоҷикистон",
      "Tojikobod (Haqiqat)": "Тоҷикобод (Хакикат)",
      "Vose TB Center": "ТБ Центр Восеъ",
      "District HC Vose": "РЦЗ Восеъ",
      "Ohchar": "Охҷар",
      "Bahoriston": "Бахористон",
      "Kaduchi 1": "Кадучи 1",
      "Kaduchi 3": "Кадучи 3",
      "Sulhobod": "Сулҳобод",
      "Fayzobod": "Файзобод",
      "Guliston": "Гулистон",
      "Kaftarhona": "Кафтархона",
      "Toskala": "Тоскала",
      "Shobika": "Шобика",
      "Zarkoron": "Заркорон",
      "Selbur": "Селбур",
      "Sarichashma": "Саричашма",
      "Hasan Kurbon": "Хасан Курбон",
      "Gulobod": "Гулобод",
      "Navbahor": "Навбахор",
      "Kurboshaid 1": "Курбошаид 1",
      "Gelot": "Гелот",
      "Darnaychi": "Дарнайчи",
      "Kurboshaid 2": "Курбоншаид 2",
      "S.Sharif": "С.Шариф",
      "Gulrud": "Гулруд",
      "Pahtakor": "Пахтакор",
      "Istiqlol": "Истиклол",
      "Voseobod": "Восеъобод",
      "Homid barot": "Хомид Барот",
      "Tugarak": "Тугарак",
      "Javoni": "Чавони",
      "Navobod": "Навобод",
      "Chorbog": "Чорбог",
      "Zarkamar": "Заркамар",
      "Kaduchi 2": "Кадучи 2",
      "Pushyoni miyona": "Пушёни миёна",
      "Hulbek": "Хулбек",
      "Zafarobod": "Зафаробод",
      "Rudaki": "Рудаки",
      "Anoriston": "Анористон",
      "Kaynar": "Кайнар",
      "Dangara TB Center": "ТБ Центр Дангара",
      "District HC Dangara": "РЦЗ Дангара",
      "Tojmahal (Lohur)": "Точмахал (Лохур)",
      "Hoja Shakiki Balhi (Sebiston)": "Хоча Шакики Балхи (Себистон) ",
      "District HC Shamol dara (Gumsu)": "РЦЗ Шамол дара (Гумсу)",
      "Bulyoni poyon": "Булёни Поен",
      "Guliston": "Гулистон",
      "District HC Navobod": "РЦЗ Навобод",
      "Gargara": "Гаргара",
      "Mehtar (Sargaron)": "Мехтар (Саргазон)",
      "Chorsada": "Чорсада",
      "Osmon dara (Hachaguzar) ": "Осмон дара (Хачагузар) ",
      "Sangtuda": "Сангтуда",
      "Dangarai bolo": "Дангараи Боло",
      "Hurramzamin (Jarteppa)": "Хуррамзамин (Чартеппа)",
      "Bobotuphona": "Боботупхона ",
      "Bulyoni Bolo": "Булёни Боло",
      "Fayzbahsh (Qushbuloq)": "Файзбахш (Кушбулок)",
      "Safobahsh (Oqsu)": "Сафобахш (Оксу)",
      "Malikova": "Маликова ",
      "Pushing": "Пушинг",
      "Alijon": "Аличон",
      "Gichovak": "Гичовак",
      "J.Balkhi TB Center": "ТБ Центр Ч.Балхӣ",
      "District HC balkhi": "РЦЗ Балхи",
      "Navobod": "Навобод",
      "Qizil-Tojikiston": "Кизил-Точикистон",
      "Uzun": "Узун",
      "Sanoat": "Саноат",
      "K-Marks": "К-Маркс",
      "A.Dustov": "А Дустов",
      "Lohuti": "Лохути",
      "Leningrad": "Ленинград",
      "Toshrobod": "Тошробод",
      "Isankulov": "Исанкулов",
      "Guliston": "Гулистон",
      "Hosilot": "Хосилот",
      "Frunze": "Фрунзе",
      "Sino": "Сино",
      "Ittifoq": "Иттифок",
      "U.Namozov": "У. Намозов",
      "Kalenin": "Каленин",
      "Dusti TB Center": "ТБ Центр Дусти",
      "District HC Dusti": "РЦЗ Дусти",
      "Nayson (Agronom)": "Найсон (Агроном)",
      "Ergash Sultonov": "Эргаш Султонов",
      "Markaz (Engels)": "Марказ (Энгелс)",
      "Istiqlol (Lebap)": "Истиқлол (Лебап)",
      "Dehqonobod": " Деҳқонобод",
      "Qubodiyon": "Қабодиён",
      "Achisel (Kuhdoman)": " Ачисел (Куҳдоман)",
      "Shahrinav": " Шаҳринав",
      "20 sol. Istiqloliyati Tojikiston (Garauti)": "20 сол. Ист-ти Ҷ.Т. (Гараути)",
      "Eshbek Sattorov": "Эшбек Сатторов",
      "Dusti": "Дусти",
      "Buston": " Бустон",
      "Gogol": " Гогол ",
      "Komsomol": " Комсомол",
      "Qubodiyon TB Center": "ТБ Центр Кабодиён",
      "District HC Qubodiyon": "РЦЗ Кабодиён",
      "Alisher Navoi": "Алишер Навоӣ",
      "Pahtakor": "Пахтакор",
      "Arabhona": "Арабхона",
      "Ziraki": "Зираки",
      "Avesto": "Авесто",
      "Chorqurgan": "Ҷаркурған",
      "Vahdat (Qizil Ittifoq)": "Вахдат (Кизил Иттифок)",
      "Oq-Oltin": "Ок-Олтин",
      "Farogat": "Фарогат",
      "Tojikiston": "Точикистон",
      "8-mart": "8-март",
      "Kamarob": "Камароб",
      "N.Husrav": "Н-Хусрав",
      "Qubodiyon": "Кубодиён",
      "Chimgilish": "Чимгилиш",
      "Uchqunobod": "Учқунобод",
      "Jayhun TB Center": "ТБ Центр Чайхун",
      "District HC Jayhun": "РЦЗ Чайхун",
      "District HC - 1 (Hasanov)": "РЦЗ - 1 (Ҳасанов)",
      "Lohuti-1": "Лоҳути-1",
      "Vakhsh": "Вахш",
      "District HC № 2": "РЦЗ № 2",
      "District HC № 8": "РЦЗ № 8",
      "Sari pul": "Сари пул",
      "District HC № 3 (Rahmonov)": "РЦЗ № 3 (Раҳмонов)",
      "Orzu": "Орзу",
      "Eshhonov (District HC - 4)": "Эшхонов (РЦЗ - 4)",
      "E.Mahmadov (District HC - 5)": "Эмахмадов (РЦЗ - 5)",
      "Hamadoni TB Center": "ТБ Центр Хамадони",
      "District HC Qabulgoh": "РЦЗ Кабулгоҳ",
      "Gulobod": "Гулобод ",
      "Dashtigulo": "Даштигуло",
      "Darai kalot (Fayzali Saidov)": "Дараи калот (Файзали Саидов)",
      "D. Halifaev": "Д. Халифаев",
      "Dusti": "Дӯсти",
      "Davlatobod": "Давлатобод",
      "Mehnatobod": "Мехнатобод",
      "M. Rahimov": "М. Рахимов",
      "Margob": "Маргоб",
      "Oqmazor (Mehrvar)": "Оқмазор (Мехрвар)",
      "Pushkin": "Пушкин",
      "Safedob": "Сафедоб",
      "Sarhadchi": "Сарҳадчи",
      "Sovetobod (Obshoron)": "Советобод (Обшорон)",
      "S. Turdiyev": "С. Турдиев",
      "Tagnob": "Тагноб",
      "Hoja Mumin": "Хоҷа Мумин",
      "Muminobod TB Center": "ТБ Центр Муъминобод",
      "District HC Muminobod": "РЦЗ Муминабад",
      "Shahri nav": "Шаҳри нав",
      "Gesh": "Ғеш",
      "Momandiyon": "Момандиён",
      "Kulchashma": "Кулчашма",
      "Sadbargoh": "Садбаргох",
      "Hanatarosh": "Ханатарош",
      "Sarmaydon": "Сармайдон",
      "Tutqavul": "Тутқавул",
      "Dehlolo": "Деҳлоло",
      "Ohjar (Navbahor)": "Охҷар (Навбахор)",
      "Dusti (Sarsibuloq)": "Дусти (Сарсибулок)",
      "Boggai": "Боғгаи",
      "Chorbog (Chuqurqishloq)": "Чорбог(Чуқуркишлок)",
      "Langar": "Лангар",
      "Tuto": "Туто",
      "Momirak": "Момирак",
      "Bogi Habib": "Боғи Ҳабиб",
      "(Sh.Shohin) Tu-tu": "(Ш.Шохин)Ту-ту",
      "Sangdara": "Сангдара",
      "Qipchoq (Chashmasor)": "Қипчок (Чашмасор)",
      "Shahrak": "Шаҳрак",
      "Dehibaland": "Дехибаланд",
      "N.Hisrav TB Center": "ТБ Центр Носири Хусрав",
      "District HC N.Hisrav": "РЦЗ Носири Хусрав",
      "Kamsomol": "Комсомол",
      "Orzu-1": "Орзу-1",
      "Voroshilov (Beshkapa)": "Ворошилов (Бешкапа)",
      "Beshkent-2 (Tulaganov)": "Бешкент-2 (Тулаганов)",
      "Norak TB Center": "ТБ Центр Нурек",
      "CHC Norak": "ГЦЗ Нурек",
      "Dukoni": "Дуконӣ",
      "Tutqavul": "Тутқавул",
      "Langar": "Лангар",
      "Panj TB Center": "ТБ Центр Пяндж",
      "District HC Panj": "РЦЗ Пяндж",
      "Orjonikidze": "Орджоникидзе ",
      "Komsomol": "Комсомол ",
      "Safedorun": "Сафедорун ",
      "Turdi Shayh": "Турди Шайх",
      "Madaniyat ": "Маданият ",
      "Nuri Vahdat (Tugul)": "Нури Вахдат (Тугул)",
      "Kuldimon uch. Q-Yulduz": "Кулдимон уч. Қ-Юлдуз",
      "Kirov (Bedak)": "Киров (Бедак)",
      "Somoni": "Сомони ",
      "Namuna Peshqadam": "Намуна Пешқадам ",
      "Pahtakor": "Пахтакор ",
      "Dehbaland": "Деҳбаланд",
      "Temurmalik TB Center": "ТБ Центр Темурмалик",
      "District HC Temurmalik": "РЦЗ Темурмалик",
      "Kangurt": "Кангурт",
      "Safarboyon": "Сафарбоён",
      "Chavroq": "Чавроқ",
      "Dusti Shuluptu": "Дусти Шулупту",
      "Boboyunus": "Бобоюнус",
      "Bahoriston (Jantoqli)": "Баҳористон (Ҷантоқли)",
      "Tanobchi": "Танобчи",
      "Qushqiya (L.Karmishev)": "Қушқия (Л.Кармишев)",
      "Vatan (S. Rahimov)": "Ватан (С. Рахимов)",
      "Davad": "Давад",
      "Farhor TB Center": "ТБ Центр Фархор",
      "District HC Farhor": "РЦЗ Фархор",
      "Vatan (Lenin)": "Ватан (Ленин)",
      "Kuhdoman (Mayda pata) ": "Куҳдоман (Майда пата) ",
      "Sadoqat (Qizil mojir)": "Садоқат (Қизил моҷир)",
      "Kuhandiyori poyon (Orjonikidze)": "Куҳандиёри поён (Орчоникидзе)",
      "Lolazor": "Лолазор",
      "Haqiqat (Pravda)": "Ҳақиқат (Правда)",
      "Kuhandiyori Bolo (Saksanohur)": "Куҳандиёри Боло (Саксанохур)",
      "Sebi Surh": "Себи Сурх",
      "Gayrat (Dehqonariq)": "Ғайрат (Деҳқонариқ)",
      "25 – solagii Tojikiston": "25 – солагии Тоҷикистон",
      "Zafar (40-solagii Tojikiston)": "Зафар (40-солагии Тоҷикистон)",
      "Archa": "Арча",
      "Shorqul": "Шурқул",
      "Bobosafoli poyon": "Бобосафоли поён",
      "Alovudin": "Аловудин",
      "Hurramzamin (Tugul)": "Хуррамзамин (Тугул)",
      "Gulshan": "Гулшан",
      "Mojirobod": "Моҷиробод",
      "Darqad": "Дарқад",
      "Mehrobod (Jayrali)": "Меҳробод (Ҷайрали)",
      "Galaba": "Ғалаба",
      "20 sol. Istiqloliyat (Komsomol)": "20 сол. Ист-т (Комсомол)",
      "Navruz": "Навруз",
      "Hisor": "Ҳисор",
      "Qizil – su ": "Қизил – су ",
      "Surhob": "Сурхоб",
      "Hovaling Tb Center": "Ховалинг",
      "District HCC Hovaling": "District HCC Ховалинг",
      "Vose": "Восеъ ",
      "Dorobi": "Дороби ",
      "Chuqurak": "Чукурак ",
      "Darai Muhtor": "Дараи Мухтор ",
      "Tokak": "Токак ",
      "Lohuti": "Лохути ",
      "Sangrezgi": "Сангрезги ",
      "Obidara": "Обидара ",
      "Zarkuh": "Заркух",
      "Halqayor": "Халкаёр ",
      "Navroho (Kuldara)": "Навроҳо (Кулдара)",
      "Chashmabedak": "Чашмабедак ",
      "Sadbargo": "Садбарго ",
      "Chombaht": "Чомбахт ",
      "Sari-Osiyob ": "Сари-Осиёб ",
      "Safedshahrak": "Сафедшахрак ",
      "Gulzor": " Гулзор",
      "Zelolak": " Зелолак",
      "Sangdara": "Сангдара",
      "Shugnov": " Шугнов",
      "Huroson TB Center": "ТБ Центр Хуросон",
      "District HC Huroson": "РЦЗ Хуросон",
      "Jabbor Rasulov": "Ҷаббор Расулов",
      "Tokparvar": "Токпарвар",
      "Nizomi": "Низомӣ",
      "Mehnatobod-2": "Меҳнатобод-2",
      "Jalolidini Rumi": "Ҷалолиддини Румӣ",
      "Alisher Navoi": "Алишер Навоӣ",
      "Tursun Uljaboev": "Турсун Улҷабоев",
      "Achchi": "Аччи",
      "Mirzorahimov (Uyali)": "Мирзораҳимов (Уяли)",
      "Chorbog": "Чорбоғ",
      "Qizil-Qala": "Қизил-қалъа",
      "Mehnatobod-1": "Меҳнатобод-1",
      "Shahritus TB Center": "ТБ Центр Шаҳритус",
      "District HC Shahritus": "РЦЗ Шаҳритус",
      "Ayvadj": "Айвадж ",
      "Iskra": "Искра ",
      "Pahtaobod": "Пахтаобод ",
      "Mashinizatsiya (Ustokoron)": "Машинизатсия (Устокорон)",
      "Sayod": "Сайёд ",
      "Hushodi": "Хушоди ",
      "Tojikobod": "Точикобод ",
      "Birlash": "Бирлаш ",
      "Hokak": "Хокак ",
      "Obshoron": "Обшорон ",
      "Sh.Shohin TB Center": "ТБ Центр Ш.Шоҳин",
      "District HC Sh.Shohin": "РЦЗ Ш.Шоҳин",
      "Zulmobod": "Зулмобод",
      "Devdor": "Девдор",
      "Dogiston": "Доғистон",
      "Shahribarbar": "Шахрибарбар",
      "Darai Ob": "Дараи об",
      "Kaftar": "Кафтар",
      "Chagam": "Чагам",
      "Sarichashma": "Саричашма",
      "Yalabuli (Pistamazor)": "БТ Ялабули (Пистамазор)",
      "Yol": "Ёл",
      "Porvor": "Порвор",
      "Hirmanjo": "Хирманҷо",
      "Dashtijum": "Даштиҷум",
      "Langar": "Лангар",
      "Navo": "Наво",
      "Yovon TB Center": "ТБ Центр Ёвон",
      "District HC Yovon": "РЦЗ Ёвон ",
      "Chrmagzak": "Чормағзак",
      "Dusti": "Дусти",
      "Shirinbuloq": "Ширинбулоқ",
      "Ozodi": "Озоди",
      "Charogchi": "Чарогчи",
      "Dahana": "Даҳана",
      "Garav": "Ғарав",
      "Gulsara Yusupova (Navkoram)": "Гулсара Юсупова (Навкорам)",
      "Dashtobod": "Даштобод",
      "Tagoyobod": "Тағойобод",
      "Qashqaraha": "Қашқараҳа",
      "Qirgochak (Anoriston)": "Қирғочак (Анористон)",
      "Qaynama": "Қайнама",
      "Parchasoy": "Парчасой",
      "Rudaki": "Рудаки",
      "Navobodi - 4": "Навободи - 4",
      "Furqat": "Фурқат",
      "Hayoti-nav": "Ҳаёти-нав",
      "Hamza": "Ҳамза",
      "Sadi-Sherozi": "Саъди-Шерозӣ",
      "Urta-qaynar": "Урта-қайнар",
      "Pahtakor (Eshma)": "Пахтакор (Эшма)",
      "Bosh-qaynar": "Бош-қайнар",
      "Bahor": "Баҳор ",
      "Shurcha": "Шурча",
      "Gulafshon": "Гулафшон",
      "Qulobod": "Қулобод",
      "Buston-2": " Бустон-2",
      "Guliston Kunchi+buston-1": "Гулистон Кунчи+бустон-1"
    }
  }
};

i18n
  .use(LngDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;